var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1237,
    height: 532,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1237 532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-13e14e2d-a036-460d-b35a-d1cb972d5a17{fill:#111113;}.uuid-652e3418-311d-4d10-9d2c-9d05c27c87ee{opacity:.4;}.uuid-652e3418-311d-4d10-9d2c-9d05c27c87ee,.uuid-138b7916-802c-4076-b291-746c2bdc540f{fill:#b4ddc0;}.uuid-652e3418-311d-4d10-9d2c-9d05c27c87ee,.uuid-0fad4a6a-88b9-4554-a230-43abd2b5b0da,.uuid-12478e0d-e418-4c83-bf57-524611b76b41{isolation:isolate;}.uuid-a2f6ca68-06e6-4ca1-b843-5b2d1633141f{fill:url(#uuid-1ab82e68-3d25-470a-9899-98a6cf5780ef);}.uuid-ef529fd9-ce42-481c-be87-753d4e985d61{fill:#2f2f31;mix-blend-mode:screen;opacity:.5;}.uuid-948682f5-4743-463a-a44f-3033288056aa{fill:#bdb6ba;}.uuid-ca3cafad-d740-4a9d-aba6-eefe2077f3c9{fill:#bcc7cb;}.uuid-ae4d9427-b523-4b15-9b6e-ad108f2e3757{fill:#7c7e80;}.uuid-18cc7b95-acff-425d-9f99-f19ab21441ff{fill:#bababa;}.uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577{fill:#fff;}.uuid-eee12681-4c10-4a7f-8c7a-00df7b659c50{fill:url(#uuid-ba1c0127-6641-4796-a334-afca9a49a34c);}.uuid-049f6520-edbe-48d3-8a64-63cdd7719105{fill:#2f3a3e;}.uuid-0ba2a92d-6071-4eda-9bb7-1aebfe869771{fill:url(#uuid-15750667-4479-473e-90b6-9903560b428a);}.uuid-62be9ac4-d1e8-4431-af78-13486ffb2dc9{fill:url(#uuid-24bb4990-6d6b-4367-ae39-246a5f1225ba);}.uuid-1d623e41-2ebf-4aae-83e7-071780e63a34{fill:#3e4442;}.uuid-3f593725-bee3-4c88-a6d8-7c438bd53176{fill:#e2bf9a;}.uuid-86a05a66-cc6b-4934-9213-d7df16391bbf{fill:#566479;}.uuid-5b9d6345-f7d5-4446-96ef-628895db4957{fill:#bbbdbf;}.uuid-91107ac9-188d-48f1-8090-dfb5fa821614{fill:url(#uuid-4cc94888-e739-4f1b-86e8-a179014bb338);}.uuid-5fbe8f06-6f48-4058-9c4e-e3d33b3aa6f3{fill:none;stroke:url(#uuid-22f9fe3c-9273-4f8e-a949-6817d4c9c2be);stroke-miterlimit:10;stroke-width:1.2px;}.uuid-deededdd-919a-4827-8ac2-84525afd6615{fill:url(#uuid-4a86fc71-fca5-4778-bd1e-a6e6b63f073b);}.uuid-2459c03a-082c-47a0-9940-0c9ba620a998{fill:#eaf7f9;}.uuid-29a2f679-1508-4734-914b-12febce24bef{fill:#666;}.uuid-a57ba21b-7790-4d7f-989b-1a2a0355870e{fill:#637c86;mix-blend-mode:multiply;opacity:.6;}.uuid-a7deae4d-b881-46d2-859a-e9e2e2b974fe{fill:url(#uuid-c5dedd41-de6d-42a5-bd21-e7336e7a8cd3);}.uuid-79de07c4-6952-4263-986f-214ff339c15b{fill:#111115;}.uuid-716ec5c1-e302-4c04-88d1-b98d60d61f7b{fill:#b8babc;}.uuid-12478e0d-e418-4c83-bf57-524611b76b41{fill:url(#uuid-6735684e-b97a-49d8-83cb-736293c52d37);opacity:.3;}.uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f{fill:#c70039;}.uuid-552ee280-7174-4e6c-9fe8-ac80b100ab1a{fill:#aaacaf;}.uuid-a82f2f8b-8d2f-4610-9121-639e5826719a{fill:#8d9092;}.uuid-9d2f3c92-885f-4e69-a317-ed525422d31a{fill:url(#uuid-54ec6b27-6b11-409d-9eb9-75d8ec40789b);}.uuid-24e4386a-2ed0-47c6-afca-db6952a1ebfc{fill:#cbccce;}.uuid-8e7a15dd-d9f1-4d22-adec-a0a84785f07c{fill:#dcddde;}.uuid-67871640-bc58-48e5-853a-79e545001da8{fill:#b4cdd8;}.uuid-b7c669bf-a446-4474-b345-4ca2e7289cc0{fill:url(#uuid-64909468-1b01-44d7-a141-b0aeb164d9ba);}.uuid-7766015f-2911-4eca-a04d-9866afa2304d{fill:#7f949c;}.uuid-698d1253-63a3-4b79-af5b-caeff2b2347d{fill:#779483;}.uuid-4a1edc6a-7a81-4964-bda5-a2a706c89440{fill:#9ea1a3;}.uuid-2409ca6d-a3bf-479d-acc7-c70dbae95e5a{fill:#343434;}.uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5{fill:#d9d9d9;}.uuid-ec085305-72e8-4d9a-8dff-59ca80e16cc2{fill:url(#uuid-7332cec7-e70e-48ab-bd95-b1275a340ac9);}.uuid-8ea17490-a4de-462e-94e9-e0f14cd0fe83{fill:#333739;}.uuid-c192b539-5692-4553-802b-d1fa156251dd{fill:#d1d3d4;}.uuid-b890e116-46a0-4576-bdde-aa989450a094{fill:url(#uuid-500565e9-6ba4-438c-aae3-32f04ff18046);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-22f9fe3c-9273-4f8e-a949-6817d4c9c2be",
    x1: 721,
    y1: 126.5,
    x2: 1237,
    y2: 126.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-15750667-4479-473e-90b6-9903560b428a",
    x1: 331.8,
    y1: 316.8,
    x2: 427.9,
    y2: 316.8,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1C1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b2d2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#46494d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#595d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#65696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#696d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#676b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#424448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#26282b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#161718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#101112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#141516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#313336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4d51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585c61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-24bb4990-6d6b-4367-ae39-246a5f1225ba",
    x1: 331.8,
    y1: 321.3,
    x2: 427.9,
    y2: 321.3,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1C1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#232527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#37393c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#424549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#46494d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#414448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#26282a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#161718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-54ec6b27-6b11-409d-9eb9-75d8ec40789b",
    x1: 337.4,
    y1: 327.9,
    x2: 422.3,
    y2: 327.9,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b2d2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#46494d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#595d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#65696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#696d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#676b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#424448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#26282b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#161718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#101112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#141516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#313336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4d51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585c61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1ab82e68-3d25-470a-9899-98a6cf5780ef",
    x1: 337.4,
    y1: 335.8,
    x2: 422.3,
    y2: 335.8,
    xlinkHref: "#uuid-24bb4990-6d6b-4367-ae39-246a5f1225ba"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-7332cec7-e70e-48ab-bd95-b1275a340ac9",
    x1: 369.6,
    y1: 317.1,
    x2: 390.1,
    y2: 337.6,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d17b4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffdb9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fdd799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f5cd8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e8ba7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d6a162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c08041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ba7839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c27f42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d69159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9935c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-500565e9-6ba4-438c-aae3-32f04ff18046",
    x1: 364.6,
    y1: 329.7,
    x2: 365.3,
    y2: 330.4,
    xlinkHref: "#uuid-15750667-4479-473e-90b6-9903560b428a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-4cc94888-e739-4f1b-86e8-a179014bb338",
    x1: 364.6,
    y1: 324.2,
    x2: 365.3,
    y2: 324.8,
    xlinkHref: "#uuid-15750667-4479-473e-90b6-9903560b428a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c5dedd41-de6d-42a5-bd21-e7336e7a8cd3",
    x1: 394.4,
    y1: 329.7,
    x2: 395.1,
    y2: 330.4,
    xlinkHref: "#uuid-15750667-4479-473e-90b6-9903560b428a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-64909468-1b01-44d7-a141-b0aeb164d9ba",
    x1: 394.4,
    y1: 324.2,
    x2: 395.1,
    y2: 324.8,
    xlinkHref: "#uuid-15750667-4479-473e-90b6-9903560b428a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-4a86fc71-fca5-4778-bd1e-a6e6b63f073b",
    x1: 349.4,
    y1: 332.9,
    x2: 410.3,
    y2: 438.4,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fabad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d5e5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c3cdcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddecf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-6735684e-b97a-49d8-83cb-736293c52d37",
    x1: 342.7,
    y1: 348.6,
    x2: 417,
    y2: 422.8,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d9799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#959fa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#aab6b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#c5d3d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e6f6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#dcebef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#bac7ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a2adaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#939d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8e9799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#939c9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a1abae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b8c4c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#d8e7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e6f6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d9799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ba1c0127-6641-4796-a334-afca9a49a34c",
    x1: 459.9,
    y1: -595.3,
    x2: 461,
    y2: -595.3,
    gradientTransform: "translate(-207.4 752.7) scale(.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1C1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#001b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00202b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00222d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#001d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1C1B1Be15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1B"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "uuid-0fad4a6a-88b9-4554-a230-43abd2b5b0da"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-639bed7a-b1eb-4528-b2ad-504e34c609ba"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1237,
    height: 532
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M721,90.7h8.5c4.6,0,8.2,2.4,8.2,7s-3.5,7.4-8.6,7.4h-4.6v10.5h-3.5v-24.8ZM724.5,102.2h4.4c3.1,0,5.2-1.1,5.2-4.5s-2.1-4.2-5.1-4.2h-4.5v8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M741,103.4c0-2.9,0-5.2,0-6.2h3.3c0,.9,0,2,0,3.6.8-2.1,2.8-3.9,5.9-3.9v3.5c-4.1.1-5.8,2.3-5.8,6.3v8.9h-3.3v-12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M768.1,106c0,5.3-2.4,9.8-8.3,9.8s-8.1-4.7-8.1-9.7,2.6-9.3,8.3-9.3,8.1,4,8.1,9.2ZM755.2,106.1c0,4.2,1.6,7,4.8,7s4.7-2.8,4.7-7-1.6-6.5-4.8-6.5-4.7,2.7-4.7,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M786.6,89.3v21.4c0,1.8,0,3.7,0,4.8h-3.3c0-.5-.1-1.6-.1-2.6-.9,2-2.4,2.9-5.4,2.9-4.7,0-7.1-4-7.1-9.5s2.8-9.6,7.7-9.6,4.3,1.1,4.7,2.1v-9.6h3.3ZM774.3,106.2c0,4.3,1.8,6.8,4.6,6.8s4.6-2.8,4.6-7-1.3-6.4-4.4-6.4-4.8,2.3-4.8,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M805.8,110.2c0,2.4,0,4.3,0,5.2h-3.2c-.1-.5-.1-1.6-.2-2.8-.9,2-2.7,3.1-5.3,3.1s-5.6-1.6-5.6-6.3v-12.3h3.3v11.7c0,2.3.7,4.1,3.4,4.1s4.2-1.7,4.2-5.5v-10.2h3.4v13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M825.1,109.5c-.7,3.6-3,6.3-7.5,6.3s-7.8-3.4-7.8-9.5,2.8-9.5,8-9.5,7,3.5,7.3,6.5h-3.4c-.3-2-1.4-3.8-4-3.8s-4.5,2.8-4.5,6.7,1.6,6.9,4.5,6.9,3.5-1.5,4.1-3.6h3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M827,97.2h2.9v-5.3h3.3v5.3h3.6v2.7h-3.6v11.1c0,1.5.4,2.1,1.9,2.1s.9,0,1.4-.1v2.5c-.8.3-1.9.3-2.5.3-2.8,0-4.1-1.1-4.1-4.2v-11.6h-2.9v-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M841.8,110.1c.3,2,1.8,3.1,3.9,3.1s3.4-1.2,3.4-2.7-1.1-2.4-4.2-3.2c-4.5-1.2-5.7-2.9-5.7-5.4s1.6-5.2,6.3-5.2,6.3,2.5,6.5,5.3h-3.3c-.3-1.4-1-2.8-3.4-2.8s-2.8.9-2.8,2.3.7,2,3.7,2.8c4.7,1.3,6.2,2.9,6.2,5.8s-2.8,5.5-6.8,5.5-6.8-1.8-7.1-5.7h3.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-5fbe8f06-6f48-4058-9c4e-e3d33b3aa6f3",
    x1: 1237,
    y1: 126.5,
    x2: 721,
    y2: 126.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M737.1,178.8c-.6,3.2-2.7,6.2-7.4,6.2s-8.2-4.6-8.2-10.9,2.5-10.5,8.3-10.5,6.7,2.7,7.2,6.3h-2c-.6-2.7-2.1-4.5-5.3-4.5s-6.2,4.1-6.2,8.8,1.4,9.1,6.2,9.1,4.6-1.8,5.4-4.4h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M752.7,176.9c0,4.4-1.8,8.1-6.6,8.1s-6.3-3.8-6.3-8,2.2-7.7,6.5-7.7,6.4,3.1,6.4,7.6ZM741.8,177c0,3.6,1.5,6.3,4.5,6.3s4.4-2.7,4.4-6.4-1.5-5.9-4.5-5.9-4.4,2.5-4.4,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M756.2,174.7c0-2.4,0-4.5,0-5.1h1.9c0,.7,0,1.7,0,3.2.8-2.1,2.6-3.5,5-3.5v2c-3.5.2-5,2.5-5,5.7v7.6h-1.9v-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M767.4,182.7v8.1h-1.9v-16.7c0-2.1,0-3.6,0-4.5h1.9c0,.5,0,1.7,0,2.6.8-1.7,2.4-2.9,4.8-2.9s5.6,2.7,5.6,7.6-2.7,8.1-6.2,8.1-3.6-1-4.3-2.3ZM775.9,177c0-3.8-1.5-5.9-4.2-5.9s-4.4,2.4-4.4,6.2.6,6,4.2,6,4.4-2.3,4.4-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M793.2,176.9c0,4.4-1.8,8.1-6.6,8.1s-6.3-3.8-6.3-8,2.2-7.7,6.5-7.7,6.4,3.1,6.4,7.6ZM782.3,177c0,3.6,1.5,6.3,4.5,6.3s4.4-2.7,4.4-6.4-1.5-5.9-4.5-5.9-4.4,2.5-4.4,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M796.7,174.7c0-2.4,0-4.5,0-5.1h1.9c0,.7,0,1.7,0,3.2.8-2.1,2.6-3.5,5-3.5v2c-3.5.2-5,2.5-5,5.7v7.6h-1.9v-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M815.9,181.6c0,1.1.1,2.4.2,3.1h-1.8c0-.6-.2-1.3-.2-2.5-.6,1.6-2.1,2.8-4.7,2.8-3.7,0-4.7-2.5-4.7-4.6s1.3-4.7,6.8-4.7h2.5v-1.6c0-1.5-.4-3.2-3.3-3.2s-3.3,1.1-3.5,2.9h-1.9c.3-2.6,1.7-4.5,5.5-4.5s5.1,1.3,5.1,4.6v7.6ZM814.1,177.2h-2.6c-4,0-4.8,1.6-4.8,3.1s1,3,3,3c3.2,0,4.3-2.2,4.3-5.8v-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M818.1,169.6h2.5v-4.5h1.9v4.5h3.2v1.6h-3.2v10.1c0,1.3.3,1.9,1.7,1.9s1,0,1.3-.1v1.5c-.5.2-1.3.2-1.8.2-1.9,0-3-.7-3-3.1v-10.6h-2.5v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M829.3,177.5c0,3.5,1.5,5.9,4.3,5.9s3.5-1.9,3.8-2.8h1.9c-.4,1.6-1.8,4.4-5.8,4.4s-6.1-3.9-6.1-7.9,1.8-7.8,6.3-7.8,5.9,3.7,5.9,7,0,1.1,0,1.1h-10.2ZM837.6,175.9c0-2.9-1.2-5-4.1-5s-4,3-4.2,5h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M865.6,184.7h-1.6c0-.6-.2-1.4-.2-3.2-1.1,2.5-3.1,3.5-6.2,3.5-5.4,0-8-4.7-8-10.6s3-10.8,8.7-10.8,6.7,2.2,7.3,5.9h-2c-.7-2.6-2.3-4.2-5.4-4.2-4.5,0-6.6,3.9-6.6,9s1.9,8.9,6.2,8.9,5.8-3.4,5.8-7.7h0c0-.1-5.8-.1-5.8-.1v-1.8h7.7v11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M870.7,162.8h1.9v3h-1.9v-3ZM870.7,169.6h1.9v15.1h-1.9v-15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M877.6,184.7v-13.5h-2.4v-1.6h2.4v-2.1c0-2.6.8-4.9,3.9-4.9s1,0,1.3.2v1.7c-.3,0-.7-.1-1.3-.1-1.4,0-2,1-2,3v2.3h2.9v1.6h-2.9v13.5h-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M882.4,169.6h2.5v-4.5h1.9v4.5h3.2v1.6h-3.2v10.1c0,1.3.3,1.9,1.7,1.9s1,0,1.3-.1v1.5c-.5.2-1.3.2-1.8.2-1.9,0-3-.7-3-3.1v-10.6h-2.5v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M893.4,180.4c.3,1.9,1.8,3,3.7,3s3.2-1.3,3.2-2.7-1-2.3-3.7-3.1c-3.5-.9-4.5-2.3-4.5-4.2s1.4-4.1,4.8-4.1,4.8,2,5,4.2h-1.9c-.3-1.4-1-2.7-3.2-2.7s-2.8,1-2.8,2.4.6,1.9,3.2,2.7c3.7,1,5,2.2,5,4.6s-2.1,4.4-5.2,4.4-5.3-1.4-5.5-4.5h1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M739.5,221.4c0-3.9,0-7.8.1-10h0c-1,3.5-4.6,13.2-6.8,19.2h-1.9c-1.7-5-5.4-15.4-6.5-19.2h0c.2,2.4.2,7.1.2,10.7v8.6h-1.9v-20.8h3c2.4,6.6,5.5,15.6,6.3,18.3h0c.4-1.7,4.1-11.7,6.6-18.3h2.9v20.8h-2v-9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M747,223.5c0,3.5,1.5,5.9,4.3,5.9s3.5-1.9,3.8-2.8h1.9c-.4,1.6-1.8,4.4-5.8,4.4s-6.1-3.9-6.1-7.9,1.8-7.8,6.3-7.8,5.9,3.7,5.9,7,0,1.1,0,1.1h-10.2ZM755.3,221.9c0-2.9-1.2-5-4.1-5s-4,3-4.2,5h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M760.7,220.3c0-2.6,0-4,0-4.7h1.9c0,.4,0,1.8,0,2.3.7-1.3,2-2.6,4.2-2.6s3.3.9,3.9,2.7c.7-1.4,2.1-2.7,4.5-2.7s4.4,1.1,4.4,5.1v10.3h-1.9v-9.9c0-2-.6-3.7-3-3.7s-3.6,2.2-3.6,4.7v9h-1.9v-10.1c0-2-.8-3.6-2.9-3.6s-3.7,1.8-3.7,5v8.7h-1.9v-10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M785,223.5c0,3.5,1.5,5.9,4.3,5.9s3.5-1.9,3.8-2.8h1.9c-.4,1.6-1.8,4.4-5.8,4.4s-6.1-3.9-6.1-7.9,1.8-7.8,6.3-7.8,5.9,3.7,5.9,7,0,1.1,0,1.1h-10.2ZM793.3,221.9c0-2.9-1.2-5-4.1-5s-4,3-4.2,5h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M798.7,220.3c0-3.2,0-4.1,0-4.7h1.9c0,.3,0,1.9,0,2.5.6-1.4,2-2.8,4.5-2.8s4.8,1.4,4.8,5.7v9.7h-1.9v-9.4c0-2.4-.9-4.2-3.3-4.2s-4.2,2.4-4.2,5.7v7.9h-1.9v-10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M812.2,215.6h2.5v-4.5h1.9v4.5h3.2v1.6h-3.2v10.1c0,1.3.3,1.9,1.7,1.9s1,0,1.3-.1v1.5c-.5.2-1.3.2-1.8.2-1.9,0-3-.7-3-3.1v-10.6h-2.5v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M834.4,222.9c0,4.4-1.8,8.1-6.6,8.1s-6.3-3.8-6.3-8,2.2-7.7,6.5-7.7,6.4,3.1,6.4,7.6ZM823.5,223c0,3.6,1.5,6.3,4.5,6.3s4.4-2.7,4.4-6.4-1.5-5.9-4.5-5.9-4.4,2.5-4.4,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M838.5,226.4c.3,1.9,1.8,3,3.7,3s3.2-1.3,3.2-2.7-1-2.3-3.7-3.1c-3.5-.9-4.5-2.3-4.5-4.2s1.4-4.1,4.8-4.1,4.8,2,5,4.2h-1.9c-.3-1.4-1-2.7-3.2-2.7s-2.8,1-2.8,2.4.6,1.9,3.2,2.7c3.7,1,5,2.2,5,4.6s-2.1,4.4-5.2,4.4-5.3-1.4-5.5-4.5h1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M722.6,255.9h6.6c4.8,0,9.1,3.2,9.1,9.9s-3.5,10.9-9.5,10.9h-6.2v-20.8ZM724.6,275h4.1c5.1,0,7.6-3.4,7.6-9.1s-3.2-8.3-7.5-8.3h-4.1v17.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M742.2,254.8h1.9v3h-1.9v-3ZM742.2,261.6h1.9v15.1h-1.9v-15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M758.8,273.6c0,1,.1,2.4.2,3.1h-1.8c0-.6-.2-1.3-.2-2.5-.6,1.6-2.1,2.8-4.7,2.8-3.7,0-4.7-2.5-4.7-4.6s1.3-4.7,6.8-4.7h2.5v-1.6c0-1.5-.4-3.2-3.3-3.2s-3.3,1.1-3.5,2.9h-1.9c.3-2.6,1.7-4.5,5.5-4.5s5.1,1.3,5.1,4.6v7.6ZM756.9,269.2h-2.6c-4,0-4.8,1.6-4.8,3.1s1,3,3,3c3.2,0,4.3-2.2,4.3-5.8v-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M763.4,266.7c0-2.4,0-4.5,0-5.1h1.9c0,.7,0,1.7,0,3.2.8-2.1,2.6-3.5,5-3.5v2c-3.5.2-5,2.5-5,5.7v7.6h-1.9v-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M772.8,254.8h1.9v3h-1.9v-3ZM772.8,261.6h1.9v15.1h-1.9v-15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M780.2,269.5c0,3.5,1.5,5.9,4.3,5.9s3.5-1.9,3.8-2.8h1.9c-.4,1.6-1.8,4.4-5.8,4.4s-6.1-3.9-6.1-7.9,1.8-7.8,6.3-7.8,5.9,3.7,5.9,7,0,1.1,0,1.1h-10.2ZM788.5,267.9c0-2.9-1.2-5-4.1-5s-4,3-4.2,5h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M794.5,272.4c.3,1.9,1.8,3,3.7,3s3.2-1.3,3.2-2.7-1-2.3-3.7-3.1c-3.5-.9-4.5-2.3-4.5-4.2s1.4-4.1,4.8-4.1,4.8,2,5,4.2h-1.9c-.3-1.4-1-2.7-3.2-2.7s-2.8,1-2.8,2.4.6,1.9,3.2,2.7c3.7,1,5,2.2,5,4.6s-2.1,4.4-5.2,4.4-5.3-1.4-5.5-4.5h1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M813.3,277l7.1-21.3h1.7l-7.1,21.3h-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M833.4,276.7v-20.8h2.7c9.1,15.5,10.2,17.5,10.6,18.4h0c-.2-2.9-.2-6.2-.2-9.6v-8.8h1.9v20.8h-2.4c-9.7-16.7-10.3-17.9-10.8-18.8h0c.2,2.7.1,6.1.1,9.9v8.9h-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M865.1,268.9c0,4.4-1.8,8.1-6.6,8.1s-6.3-3.8-6.3-8,2.2-7.7,6.5-7.7,6.4,3.1,6.4,7.6ZM854.2,269c0,3.6,1.5,6.3,4.5,6.3s4.4-2.7,4.4-6.4-1.5-5.9-4.5-5.9-4.4,2.5-4.4,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M866.7,261.6h2.5v-4.5h1.9v4.5h3.2v1.6h-3.2v10.1c0,1.3.3,1.9,1.7,1.9s1,0,1.3-.1v1.5c-.5.2-1.3.2-1.8.2-1.9,0-3-.7-3-3.1v-10.6h-2.5v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M877.9,269.5c0,3.5,1.5,5.9,4.3,5.9s3.5-1.9,3.8-2.8h1.9c-.4,1.6-1.8,4.4-5.8,4.4s-6.1-3.9-6.1-7.9,1.8-7.8,6.3-7.8,5.9,3.7,5.9,7,0,1.1,0,1.1h-10.2ZM886.2,267.9c0-2.9-1.2-5-4.1-5s-4,3-4.2,5h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M891.6,254.8h1.9v9c.7-1.3,2.1-2.6,4.7-2.6,3.6,0,5.8,2.9,5.8,7.4s-1.9,8.3-6.2,8.3-3.7-1-4.2-2.4c0,.7,0,1.4,0,2.1h-1.9c0-.8,0-2.2,0-4.1v-17.7ZM902,268.8c0-3.5-1.4-5.7-4.2-5.7s-4.4,2.1-4.4,5.9.9,6.3,4.3,6.3,4.3-2.7,4.3-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M919.3,268.9c0,4.4-1.8,8.1-6.6,8.1s-6.3-3.8-6.3-8,2.2-7.7,6.5-7.7,6.4,3.1,6.4,7.6ZM908.4,269c0,3.6,1.5,6.3,4.5,6.3s4.4-2.7,4.4-6.4-1.5-5.9-4.5-5.9-4.4,2.5-4.4,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M934.6,268.9c0,4.4-1.8,8.1-6.6,8.1s-6.3-3.8-6.3-8,2.2-7.7,6.5-7.7,6.4,3.1,6.4,7.6ZM923.7,269c0,3.6,1.5,6.3,4.5,6.3s4.4-2.7,4.4-6.4-1.5-5.9-4.5-5.9-4.4,2.5-4.4,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M940,268.9c1.5-1.6,4.9-5.3,6.8-7.3h2.3c-1.7,2-3.6,3.8-5.4,5.7,1.9,2.9,4.1,6.5,6,9.4h-2.2c-1.3-2-3.6-5.8-5.1-8.1-.5.6-1.8,1.8-2.4,2.3v5.7h-1.9v-21.9h1.9v14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M953,272.4c.3,1.9,1.8,3,3.7,3s3.2-1.3,3.2-2.7-1-2.3-3.7-3.1c-3.5-.9-4.5-2.3-4.5-4.2s1.4-4.1,4.8-4.1,4.8,2,5,4.2h-1.9c-.3-1.4-1-2.7-3.2-2.7s-2.8,1-2.8,2.4.6,1.9,3.2,2.7c3.7,1,5,2.2,5,4.6s-2.1,4.4-5.2,4.4-5.3-1.4-5.5-4.5h1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M737.1,316.8c-.6,3.2-2.7,6.2-7.4,6.2s-8.2-4.6-8.2-10.9,2.5-10.5,8.3-10.5,6.7,2.7,7.2,6.3h-2c-.6-2.7-2.1-4.5-5.3-4.5s-6.2,4.1-6.2,8.8,1.4,9.1,6.2,9.1,4.6-1.8,5.4-4.4h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M750.9,319.6c0,1,.1,2.4.2,3.1h-1.8c0-.6-.2-1.3-.2-2.5-.6,1.6-2.1,2.8-4.7,2.8-3.7,0-4.7-2.5-4.7-4.6s1.3-4.7,6.8-4.7h2.5v-1.6c0-1.5-.4-3.2-3.3-3.2s-3.3,1.1-3.5,2.9h-1.9c.3-2.6,1.7-4.5,5.5-4.5s5.1,1.3,5.1,4.6v7.6ZM749,315.2h-2.6c-4,0-4.8,1.6-4.8,3.1s1,3,3,3c3.2,0,4.3-2.2,4.3-5.8v-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M755.4,322.7v-21.9h1.9v21.9h-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M762.8,315.5c0,3.5,1.5,5.9,4.3,5.9s3.5-1.9,3.8-2.8h1.9c-.4,1.6-1.8,4.4-5.8,4.4s-6.1-3.9-6.1-7.9,1.8-7.8,6.3-7.8,5.9,3.7,5.9,7,0,1.1,0,1.1h-10.2ZM771.1,313.9c0-2.9-1.2-5-4.1-5s-4,3-4.2,5h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M776.5,312.3c0-3.2,0-4.1,0-4.7h1.9c0,.3,0,1.9,0,2.5.6-1.4,2-2.8,4.5-2.8s4.8,1.4,4.8,5.7v9.7h-1.9v-9.4c0-2.4-.9-4.2-3.3-4.2s-4.2,2.4-4.2,5.7v7.9h-1.9v-10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M803.6,300.8v18c0,1.3,0,2.9,0,3.8h-1.9c0-.4,0-1.4,0-2.4-.8,1.9-2.1,2.7-4.6,2.7-3.9,0-5.9-3.4-5.9-7.8s2.2-7.9,6.3-7.9,3.7,1.1,4.1,2v-8.4h1.9ZM793.2,315.1c0,4,1.8,6.2,4.3,6.2,3.5,0,4.2-2.7,4.2-6.5s-1.4-5.8-4.1-5.8-4.5,2.2-4.5,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M818.2,319.6c0,1,.1,2.4.2,3.1h-1.8c0-.6-.2-1.3-.2-2.5-.6,1.6-2.1,2.8-4.7,2.8-3.7,0-4.7-2.5-4.7-4.6s1.3-4.7,6.8-4.7h2.5v-1.6c0-1.5-.4-3.2-3.3-3.2s-3.3,1.1-3.5,2.9h-1.9c.3-2.6,1.7-4.5,5.5-4.5s5.1,1.3,5.1,4.6v7.6ZM816.4,315.2h-2.6c-4,0-4.8,1.6-4.8,3.1s1,3,3,3c3.2,0,4.3-2.2,4.3-5.8v-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M822.8,312.7c0-2.4,0-4.5,0-5.1h1.9c0,.7,0,1.7,0,3.2.8-2.1,2.6-3.5,5-3.5v2c-3.5.2-5,2.5-5,5.7v7.6h-1.9v-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M832.9,318.4c.3,1.9,1.8,3,3.7,3s3.2-1.3,3.2-2.7-1-2.3-3.7-3.1c-3.5-.9-4.5-2.3-4.5-4.2s1.4-4.1,4.8-4.1,4.8,2,5,4.2h-1.9c-.3-1.4-1-2.7-3.2-2.7s-2.8,1-2.8,2.4.6,1.9,3.2,2.7c3.7,1,5,2.2,5,4.6s-2.1,4.4-5.2,4.4-5.3-1.4-5.5-4.5h1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M869.5,309.9l-5,7.8c-2.7,4.1-4,5.3-7.1,5.3s-5.5-2.4-5.5-5.5,1.7-4.6,5.2-6.5c3.3-1.9,4.3-2.9,4.3-4.8s-.8-2.9-2.9-2.9-2.9,1.3-2.9,3,.7,2.5,2.5,4.3l12.3,12.1h-2.7l-11.2-11.2c-1.7-1.8-2.7-3.2-2.7-5.2s1.6-4.7,4.8-4.7,4.6,2,4.6,4.5-1.6,4-4.9,5.9c-3.3,2-4.4,3.3-4.4,5.3s1.5,3.8,3.6,3.8,3.7-1.6,5.5-4.4l4.4-6.9h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M885,303.7h-6.2v-1.8h14.5v1.8h-6.3v19h-2v-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M902.9,319.6c0,1,.1,2.4.2,3.1h-1.8c0-.6-.2-1.3-.2-2.5-.6,1.6-2.1,2.8-4.7,2.8-3.7,0-4.7-2.5-4.7-4.6s1.3-4.7,6.8-4.7h2.5v-1.6c0-1.5-.4-3.2-3.3-3.2s-3.3,1.1-3.5,2.9h-1.9c.3-2.6,1.7-4.5,5.5-4.5s5.1,1.3,5.1,4.6v7.6ZM901,315.2h-2.6c-4,0-4.8,1.6-4.8,3.1s1,3,3,3c3.2,0,4.3-2.2,4.3-5.8v-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M907.4,300.8h1.9v9c.7-1.3,2.1-2.6,4.7-2.6,3.6,0,5.8,2.9,5.8,7.4s-1.9,8.3-6.2,8.3-3.7-1-4.2-2.4c0,.7,0,1.4,0,2.1h-1.9c0-.8,0-2.2,0-4.1v-17.7ZM917.8,314.8c0-3.5-1.4-5.7-4.2-5.7s-4.4,2.1-4.4,5.9.9,6.3,4.3,6.3,4.3-2.7,4.3-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M923.3,322.7v-21.9h1.9v21.9h-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M930.6,315.5c0,3.5,1.5,5.9,4.3,5.9s3.5-1.9,3.8-2.8h1.9c-.4,1.6-1.8,4.4-5.8,4.4s-6.1-3.9-6.1-7.9,1.8-7.8,6.3-7.8,5.9,3.7,5.9,7,0,1.1,0,1.1h-10.2ZM939,313.9c0-2.9-1.2-5-4.1-5s-4,3-4.2,5h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M955.8,303.7h-6.2v-1.8h14.5v1.8h-6.3v19h-2v-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M975.5,314.9c0,4.4-1.8,8.1-6.6,8.1s-6.3-3.8-6.3-8,2.2-7.7,6.5-7.7,6.4,3.1,6.4,7.6ZM964.6,315c0,3.6,1.5,6.3,4.5,6.3s4.4-2.7,4.4-6.4-1.5-5.9-4.5-5.9-4.4,2.5-4.4,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M980.9,320.7v8.1h-1.9v-16.7c0-2.1,0-3.6,0-4.5h1.9c0,.5,0,1.7,0,2.6.8-1.7,2.4-2.9,4.8-2.9s5.6,2.7,5.6,7.6-2.7,8.1-6.2,8.1-3.6-1-4.3-2.3ZM989.3,315c0-3.8-1.5-5.9-4.2-5.9s-4.4,2.4-4.4,6.2.6,6,4.2,6,4.4-2.3,4.4-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M737.1,362.8c-.6,3.2-2.7,6.2-7.4,6.2s-8.2-4.6-8.2-10.9,2.5-10.5,8.3-10.5,6.7,2.7,7.2,6.3h-2c-.6-2.7-2.1-4.5-5.3-4.5s-6.2,4.1-6.2,8.8,1.4,9.1,6.2,9.1,4.6-1.8,5.4-4.4h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M750.9,365.6c0,1,.1,2.4.2,3.1h-1.8c0-.6-.2-1.3-.2-2.5-.6,1.6-2.1,2.8-4.7,2.8-3.7,0-4.7-2.5-4.7-4.6s1.3-4.7,6.8-4.7h2.5v-1.6c0-1.5-.4-3.2-3.3-3.2s-3.3,1.1-3.5,2.9h-1.9c.3-2.6,1.7-4.5,5.5-4.5s5.1,1.3,5.1,4.6v7.6ZM749,361.2h-2.6c-4,0-4.8,1.6-4.8,3.1s1,3,3,3c3.2,0,4.3-2.2,4.3-5.8v-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M755.4,368.7v-21.9h1.9v21.9h-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M762.8,361.5c0,3.5,1.5,5.9,4.3,5.9s3.5-1.9,3.8-2.8h1.9c-.4,1.6-1.8,4.4-5.8,4.4s-6.1-3.9-6.1-7.9,1.8-7.8,6.3-7.8,5.9,3.7,5.9,7,0,1.1,0,1.1h-10.2ZM771.1,359.9c0-2.9-1.2-5-4.1-5s-4,3-4.2,5h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M776.5,358.3c0-3.2,0-4.1,0-4.7h1.9c0,.3,0,1.9,0,2.5.6-1.4,2-2.8,4.5-2.8s4.8,1.4,4.8,5.7v9.7h-1.9v-9.4c0-2.4-.9-4.2-3.3-4.2s-4.2,2.4-4.2,5.7v7.9h-1.9v-10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M803.6,346.8v18c0,1.3,0,2.9,0,3.8h-1.9c0-.4,0-1.4,0-2.4-.8,1.9-2.1,2.7-4.6,2.7-3.9,0-5.9-3.4-5.9-7.8s2.2-7.9,6.3-7.9,3.7,1.1,4.1,2v-8.4h1.9ZM793.2,361.1c0,4,1.8,6.2,4.3,6.2,3.5,0,4.2-2.7,4.2-6.5s-1.4-5.8-4.1-5.8-4.5,2.2-4.5,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M818.2,365.6c0,1,.1,2.4.2,3.1h-1.8c0-.6-.2-1.3-.2-2.5-.6,1.6-2.1,2.8-4.7,2.8-3.7,0-4.7-2.5-4.7-4.6s1.3-4.7,6.8-4.7h2.5v-1.6c0-1.5-.4-3.2-3.3-3.2s-3.3,1.1-3.5,2.9h-1.9c.3-2.6,1.7-4.5,5.5-4.5s5.1,1.3,5.1,4.6v7.6ZM816.4,361.2h-2.6c-4,0-4.8,1.6-4.8,3.1s1,3,3,3c3.2,0,4.3-2.2,4.3-5.8v-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M822.8,358.7c0-2.4,0-4.5,0-5.1h1.9c0,.7,0,1.7,0,3.2.8-2.1,2.6-3.5,5-3.5v2c-3.5.2-5,2.5-5,5.7v7.6h-1.9v-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M832.9,364.4c.3,1.9,1.8,3,3.7,3s3.2-1.3,3.2-2.7-1-2.3-3.7-3.1c-3.5-.9-4.5-2.3-4.5-4.2s1.4-4.1,4.8-4.1,4.8,2,5,4.2h-1.9c-.3-1.4-1-2.7-3.2-2.7s-2.8,1-2.8,2.4.6,1.9,3.2,2.7c3.7,1,5,2.2,5,4.6s-2.1,4.4-5.2,4.4-5.3-1.4-5.5-4.5h1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M722.6,393.9h7c3.4,0,5.9,1.7,5.9,5.1s-1.8,4-3.1,4.4c1.4.5,3.8,1.7,3.8,5.2s-2.8,6.1-6.8,6.1h-6.7v-20.8ZM729,402.6c3.2,0,4.5-1.4,4.5-3.5s-1.3-3.5-4.2-3.5h-4.7v7.1h4.5ZM724.5,413.1h4.5c2.9,0,5-1.4,5-4.4s-1.7-4.3-5.2-4.3h-4.3v8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M750,411.6c0,1,.1,2.4.2,3.1h-1.8c0-.6-.2-1.3-.2-2.5-.6,1.6-2.1,2.8-4.7,2.8-3.7,0-4.7-2.5-4.7-4.6s1.3-4.7,6.8-4.7h2.5v-1.6c0-1.5-.4-3.2-3.3-3.2s-3.3,1.1-3.5,2.9h-1.9c.3-2.6,1.7-4.5,5.5-4.5s5.1,1.3,5.1,4.6v7.6ZM748.1,407.2h-2.6c-4,0-4.8,1.6-4.8,3.1s1,3,3,3c3.2,0,4.3-2.2,4.3-5.8v-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M765.7,413.7c0,4.7-1.9,7.3-6.2,7.3s-5.5-2.3-5.8-4.4h1.9c.4,1.9,1.9,2.7,3.9,2.7,3.5,0,4.3-2.4,4.3-5.9v-1.4c-.8,1.8-2.1,2.7-4.6,2.7s-5.8-3-5.8-7.7,2.7-7.8,6.2-7.8,3.7,1,4.1,2.3c0-.8,0-1.7.1-2h1.9c0,.7,0,2.3,0,4.3v9.8ZM755.5,407.1c0,3.8,1.6,6,4.2,6s4.2-2,4.2-6-1-6-4.1-6-4.3,2.4-4.3,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M770.5,410.4c.3,1.9,1.8,3,3.7,3s3.2-1.3,3.2-2.7-1-2.3-3.7-3.1c-3.5-.9-4.5-2.3-4.5-4.2s1.4-4.1,4.8-4.1,4.8,2,5,4.2h-1.9c-.3-1.4-1-2.7-3.2-2.7s-2.8,1-2.8,2.4.6,1.9,3.2,2.7c3.7,1,5,2.2,5,4.6s-2.1,4.4-5.2,4.4-5.3-1.4-5.5-4.5h1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M789.3,415l7.1-21.3h1.7l-7.1,21.3h-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M812.9,414.7l-5.2-20.8h2.1c2.5,9.9,3.9,15.5,4.3,18.5h0c.4-2.4,3.4-13.4,4.6-18.5h2c1.2,4.9,4.2,16.1,4.5,18.4h0c.6-3.5,3.5-13.7,4.7-18.4h2l-5.7,20.8h-2.2c-1.2-4.9-3.9-15.4-4.4-18.1h0c-.5,3-3.3,13.2-4.5,18.1h-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M843.6,411.6c0,1,.1,2.4.2,3.1h-1.8c0-.6-.2-1.3-.2-2.5-.6,1.6-2.1,2.8-4.7,2.8-3.7,0-4.7-2.5-4.7-4.6s1.3-4.7,6.8-4.7h2.5v-1.6c0-1.5-.4-3.2-3.3-3.2s-3.3,1.1-3.5,2.9h-1.9c.3-2.6,1.7-4.5,5.5-4.5s5.1,1.3,5.1,4.6v7.6ZM841.7,407.2h-2.6c-4,0-4.8,1.6-4.8,3.1s1,3,3,3c3.2,0,4.3-2.2,4.3-5.8v-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M845.7,399.6h2.5v-4.5h1.9v4.5h3.2v1.6h-3.2v10.1c0,1.3.3,1.9,1.7,1.9s1,0,1.3-.1v1.5c-.5.2-1.3.2-1.8.2-1.9,0-3-.7-3-3.1v-10.6h-2.5v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M856.9,407.5c0,3.5,1.5,5.9,4.3,5.9s3.5-1.9,3.8-2.8h1.9c-.4,1.6-1.8,4.4-5.8,4.4s-6.1-3.9-6.1-7.9,1.8-7.8,6.3-7.8,5.9,3.7,5.9,7,0,1.1,0,1.1h-10.2ZM865.3,405.9c0-2.9-1.2-5-4.1-5s-4,3-4.2,5h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M870.6,404.7c0-2.4,0-4.5,0-5.1h1.9c0,.7,0,1.7,0,3.2.8-2.1,2.6-3.5,5-3.5v2c-3.5.2-5,2.5-5,5.7v7.6h-1.9v-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M887.5,392.8h1.9v9c.7-1.3,2.1-2.6,4.7-2.6,3.6,0,5.8,2.9,5.8,7.4s-1.9,8.3-6.2,8.3-3.7-1-4.2-2.4c0,.7,0,1.4,0,2.1h-1.9c0-.8,0-2.2,0-4.1v-17.7ZM897.9,406.8c0-3.5-1.4-5.7-4.2-5.7s-4.4,2.1-4.4,5.9.9,6.3,4.3,6.3,4.3-2.7,4.3-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M915.2,406.9c0,4.4-1.8,8.1-6.6,8.1s-6.3-3.8-6.3-8,2.2-7.7,6.5-7.7,6.4,3.1,6.4,7.6ZM904.3,407c0,3.6,1.5,6.3,4.5,6.3s4.4-2.7,4.4-6.4-1.5-5.9-4.5-5.9-4.4,2.5-4.4,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M916.7,399.6h2.5v-4.5h1.9v4.5h3.2v1.6h-3.2v10.1c0,1.3.3,1.9,1.7,1.9s1,0,1.3-.1v1.5c-.5.2-1.3.2-1.8.2-1.9,0-3-.7-3-3.1v-10.6h-2.5v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M924.9,399.6h2.5v-4.5h1.9v4.5h3.2v1.6h-3.2v10.1c0,1.3.3,1.9,1.7,1.9s1,0,1.3-.1v1.5c-.5.2-1.3.2-1.8.2-1.9,0-3-.7-3-3.1v-10.6h-2.5v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M935.1,414.7v-21.9h1.9v21.9h-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M942.5,407.5c0,3.5,1.5,5.9,4.3,5.9s3.5-1.9,3.8-2.8h1.9c-.4,1.6-1.8,4.4-5.8,4.4s-6.1-3.9-6.1-7.9,1.8-7.8,6.3-7.8,5.9,3.7,5.9,7,0,1.1,0,1.1h-10.2ZM950.8,405.9c0-2.9-1.2-5-4.1-5s-4,3-4.2,5h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M956.8,410.4c.3,1.9,1.8,3,3.7,3s3.2-1.3,3.2-2.7-1-2.3-3.7-3.1c-3.5-.9-4.5-2.3-4.5-4.2s1.4-4.1,4.8-4.1,4.8,2,5,4.2h-1.9c-.3-1.4-1-2.7-3.2-2.7s-2.8,1-2.8,2.4.6,1.9,3.2,2.7c3.7,1,5,2.2,5,4.6s-2.1,4.4-5.2,4.4-5.3-1.4-5.5-4.5h1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M279.5,160.1h-2.4c0-17.8,4.7-35.4,13.6-50.8l2.1,1.2c-8.7,15-13.3,32.1-13.3,49.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M291.1,210.5c-8.8-15.3-13.5-32.7-13.5-50.5h1.2c0,17.5,4.6,34.8,13.3,49.8l-1.1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M377.9,260.4c0-.3.3-.6.6-.6h0c.3,0,.6.3.6.6h0c0,.3-.3.6-.6.6h0c-.3,0-.6-.3-.6-.6ZM374.8,260.9c-.3,0-.6-.3-.6-.6h0c0-.3.3-.6.6-.6h0c.3,0,.6.3.6.6h0c0,.3-.3.6-.6.6h0ZM371.2,260.7h0c-.3,0-.6-.3-.6-.7h0c0-.3.3-.6.7-.6h0c.3,0,.6.3.6.7h0c0,.3-.3.6-.6.6h0s0,0,0,0ZM367.5,260.4c-.3,0-.6-.3-.5-.7h0c0-.3.3-.6.7-.5h0c.3,0,.6.3.5.7h0c0,.3-.3.5-.6.5h0s0,0,0,0ZM363.9,259.9h0c-.3,0-.6-.4-.5-.7h0c0-.3.4-.6.7-.5h0c.3,0,.6.4.5.7h0c0,.3-.3.5-.6.5h0s0,0,0,0ZM360.2,259.3h0c-.3,0-.5-.4-.5-.7h0c0-.3.4-.5.7-.5h0c.3,0,.5.4.5.7h0c0,.3-.3.5-.6.5h0s0,0-.1,0ZM356.6,258.6c-.3,0-.5-.4-.5-.7h0c0-.3.4-.5.7-.5h0c.3,0,.5.4.5.7h0c0,.3-.3.5-.6.5h0s0,0-.1,0ZM353,257.7c-.3,0-.5-.4-.4-.7h0c0-.3.4-.5.7-.4h0c.3,0,.5.4.4.7h0c0,.3-.3.5-.6.5h0s0,0-.2,0ZM349.5,256.7h0c-.3,0-.5-.4-.4-.8h0c0-.3.4-.5.8-.4h0c.3,0,.5.4.4.8h0c0,.3-.3.4-.6.4h0c0,0-.1,0-.2,0ZM346,255.6c-.3-.1-.5-.5-.4-.8h0c.1-.3.5-.5.8-.4h0c.3.1.5.5.4.8h0c0,.3-.3.4-.6.4h0c0,0-.1,0-.2,0ZM342.5,254.4c-.3-.1-.5-.5-.4-.8h0c.1-.3.5-.5.8-.3h0c.3.1.5.5.4.8h0c0,.2-.3.4-.6.4h0c0,0-.1,0-.2,0ZM339.1,253c-.3-.1-.5-.5-.3-.8h0c.1-.3.5-.5.8-.3h0c.3.1.5.5.3.8h0c0,.2-.3.4-.6.4h0c0,0-.2,0-.2,0ZM335.8,251.5c-.3-.1-.4-.5-.3-.8h0c.1-.3.5-.4.8-.3h0c.3.1.4.5.3.8h0c-.1.2-.3.3-.5.3h0c0,0-.2,0-.3,0ZM332.4,249.9h0c-.3-.2-.4-.5-.3-.8h0c.2-.3.5-.4.8-.3h0c.3.2.4.5.3.8h0c-.1.2-.3.3-.5.3h0c0,0-.2,0-.3,0ZM329.2,248.1c-.3-.2-.4-.5-.2-.8h0c.2-.3.5-.4.8-.2h0c.3.2.4.5.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3,0ZM326,246.2h0c-.3-.2-.4-.5-.2-.8h0c.2-.3.5-.4.8-.2h0c.3.2.4.5.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3,0ZM322.9,244.3c-.3-.2-.4-.6-.2-.8h0c.2-.3.6-.4.8-.2h0c.3.2.4.6.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3-.1ZM319.9,242.2h0c-.3-.2-.3-.6-.1-.8h0c.2-.3.6-.3.8-.1h0c.3.2.3.6.1.9h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.4-.1ZM316.9,240c-.3-.2-.3-.6-.1-.9h0c.2-.3.6-.3.9-.1h0c.3.2.3.6.1.9h0c-.1.2-.3.2-.5.2h0c-.1,0-.3,0-.4-.1ZM314.1,237.7c-.3-.2-.3-.6,0-.9h0c.2-.3.6-.3.9,0h0c.3.2.3.6,0,.9h0c-.1.1-.3.2-.5.2h0c-.1,0-.3,0-.4-.1ZM311.3,235.3c-.2-.2-.3-.6,0-.9h0c.2-.2.6-.3.9,0h0c.2.2.3.6,0,.9h0c-.1.1-.3.2-.5.2h0c-.1,0-.3,0-.4-.2ZM308.6,232.8c-.2-.2-.3-.6,0-.9h0c.2-.2.6-.3.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.4-.2ZM306,230.2c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.2.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.4-.2ZM303.5,227.5h0c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.2.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.5-.2ZM301.1,224.7h0c-.2-.3-.2-.6,0-.9h0c.3-.2.6-.2.9,0h0c.2.3.2.6,0,.9h0c-.1,0-.2.1-.4.1h0c-.2,0-.3,0-.5-.2ZM298.8,221.9c-.2-.3-.2-.7.1-.9h0c.3-.2.7-.2.9.1h0c.2.3.2.6-.1.9h0c-.1,0-.2.1-.4.1h0c-.2,0-.4,0-.5-.2ZM296.6,218.9c-.2-.3-.1-.7.1-.8h0c.3-.2.7-.1.9.1h0c.2.3.1.7-.1.9h0c-.1,0-.2.1-.4.1h0c-.2,0-.4,0-.5-.3ZM294.5,215.9h0c-.2-.3-.1-.7.2-.8h0c.3-.2.7-.1.8.2h0c.2.3.1.7-.2.8h0c-.1,0-.2.1-.3.1h0c-.2,0-.4,0-.5-.3ZM292.5,212.8h0c-.2-.3,0-.7.2-.8h0c.3-.2.7,0,.8.2h0c.2.3,0,.7-.2.8h0c-.1,0-.2,0-.3,0h0c-.2,0-.4-.1-.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M378.5,260.7v-.6c17.9,0,35.4-4.8,50.7-13.8,14.9-8.8,27.3-21.3,35.9-36.2l.5.3c-8.7,15-21.2,27.6-36.1,36.4-15.4,9.1-33,13.9-51,13.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M291.9,110.1l-.5-.3c8.7-15,21.2-27.6,36.1-36.4,15.4-9.1,33-13.9,51-13.9v.6c-17.9,0-35.4,4.8-50.7,13.8-14.9,8.8-27.3,21.3-35.9,36.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M464.3,110.5c-8.6-14.8-20.9-27.2-35.6-35.9-15.2-8.9-32.5-13.7-50.2-13.7v-2.4c18.1,0,35.9,4.8,51.5,14,15.1,8.9,27.7,21.6,36.4,36.7l-2.1,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M468.3,111.4c0-1.2-1-2.1-2.1-2.1s-2.1,1-2.1,2.1,1,2.1,2.1,2.1,2.1-1,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M280.4,160.5c0-1.2-1-2.1-2.1-2.1s-2.1,1-2.1,2.1,1,2.1,2.1,2.1,2.1-1,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    cx: 291.7,
    cy: 210.2,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M466.5,211.2c-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8,2.8,1.2,2.8,2.8-1.2,2.8-2.8,2.8ZM466.5,206.9c-.9,0-1.6.7-1.6,1.6s.7,1.6,1.6,1.6,1.6-.7,1.6-1.6-.7-1.6-1.6-1.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    x: 378.2,
    y: 260.4,
    width: 0.6,
    height: 13.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M436.6,242.8c0-.7-.6-1.3-1.3-1.3s-1.3.6-1.3,1.3.6,1.3,1.3,1.3,1.3-.6,1.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M378.5,278.8c-1.4,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6,2.6,1.2,2.6,2.6-1.2,2.6-2.6,2.6ZM378.5,274.2c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M379.5,276.2c0-.5-.4-.9-.9-.9s-.9.4-.9.9.4.9.9.9.9-.4.9-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M379.9,260.3c0-.7-.6-1.3-1.3-1.3s-1.3.6-1.3,1.3.6,1.3,1.3,1.3,1.3-.6,1.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M273.2,473.4c-22.1,0-44.1-8.4-60.9-25.2l1.7-1.7c32.6,32.6,85.8,32.6,118.4,0l1.7,1.7c-16.8,16.8-38.9,25.2-60.9,25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M334.1,446.5c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.3.9,0h0c.2.2.3.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.4-.2ZM336.6,443.8c-.3-.2-.3-.6,0-.9h0c.2-.3.6-.3.9,0h0c.2.2.3.6,0,.9h0c-.1.1-.3.2-.5.2h0c-.1,0-.3,0-.4-.2ZM339,441c-.3-.2-.3-.6,0-.9h0c.2-.3.6-.3.9,0h0c.3.2.3.6,0,.9h0c-.1.2-.3.2-.5.2h0c-.1,0-.3,0-.4-.1ZM341.3,438.1c-.3-.2-.3-.6-.1-.9h0c.2-.3.6-.3.9-.1h0c.3.2.3.6.1.9h0c-.1.2-.3.2-.5.2h0c-.1,0-.2,0-.4-.1ZM343.4,435.2c-.3-.2-.4-.6-.2-.8h0c.2-.3.6-.4.8-.2h0c.3.2.4.6.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3-.1ZM345.4,432.1c-.3-.2-.4-.5-.2-.8h0c.2-.3.5-.4.8-.2h0c.3.2.4.5.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3,0ZM347.2,429c-.3-.2-.4-.5-.2-.8h0c.2-.3.5-.4.8-.2h0c.3.2.4.5.2.8h0c-.1.2-.3.3-.5.3h0c0,0-.2,0-.3,0ZM349,425.7c-.3-.2-.4-.5-.3-.8h0c.2-.3.5-.4.8-.3h0c.3.1.4.5.3.8h0c-.1.2-.3.3-.5.3h0c0,0-.2,0-.3,0ZM350.6,422.5c-.3-.1-.5-.5-.3-.8h0c.1-.3.5-.4.8-.3h0c.3.1.4.5.3.8h0c-.1.2-.3.4-.6.4h0c0,0-.2,0-.2,0ZM352,419.1c-.3-.1-.5-.5-.3-.8h0c.1-.3.5-.5.8-.3h0c.3.1.5.5.3.8h0c0,.2-.3.4-.6.4h0c0,0-.1,0-.2,0ZM353.3,415.7c-.3-.1-.5-.5-.4-.8h0c.1-.3.5-.5.8-.4h0c.3.1.5.5.4.8h0c0,.2-.3.4-.6.4h0c0,0-.1,0-.2,0ZM354.4,412.2c-.3,0-.5-.4-.4-.8h0c0-.3.4-.5.8-.4h0c.3,0,.5.4.4.8h0c0,.3-.3.4-.6.4h0c0,0-.1,0-.2,0ZM355.4,408.7c-.3,0-.5-.4-.4-.7h0c0-.3.4-.5.7-.4h0c.3,0,.5.4.4.7h0c0,.3-.3.5-.6.5h0s0,0-.1,0ZM356.3,405.1c-.3,0-.5-.4-.5-.7h0c0-.3.4-.5.7-.5h0c.3,0,.5.4.5.7h0c0,.3-.3.5-.6.5h0s0,0-.1,0ZM356.9,401.5c-.3,0-.6-.4-.5-.7h0c0-.3.4-.6.7-.5h0c.3,0,.6.4.5.7h0c0,.3-.3.5-.6.5h0s0,0,0,0ZM357.5,397.9c-.3,0-.6-.3-.5-.7h0c0-.3.3-.6.7-.5h0c.3,0,.6.3.5.7h0c0,.3-.3.5-.6.5h0s0,0,0,0ZM357.9,394.3c-.3,0-.6-.3-.6-.7h0c0-.3.3-.6.7-.6h0c.3,0,.6.3.6.7h0c0,.3-.3.6-.6.6h0ZM358.1,390.6c-.3,0-.6-.3-.6-.6h0c0-.3.3-.6.6-.6h0c.3,0,.6.3.6.6h0c0,.3-.3.6-.6.6h0ZM357.5,386.4c0-.3.3-.6.6-.6h0c.3,0,.6.3.6.6h0c0,.3-.3.6-.6.6h0c-.3,0-.6-.3-.6-.6ZM357.4,382.8h0c0-.3.2-.6.6-.6h0c.3,0,.6.2.6.6h0c0,.3-.2.6-.6.6h0c-.3,0-.6-.2-.6-.6ZM357.1,379.1c0-.3.2-.6.5-.7h0c.3,0,.6.2.7.5h0c0,.3-.2.6-.5.7h0s0,0,0,0h0c-.3,0-.6-.2-.6-.5ZM356.7,375.5c0-.3.2-.6.5-.7h0c.3,0,.6.2.7.5h0c0,.3-.2.6-.5.7h0s0,0,0,0h0c-.3,0-.6-.2-.6-.5ZM356.1,372h0c0-.3.2-.6.5-.7h0c.3,0,.6.2.7.5h0c0,.3-.2.6-.5.7h0s0,0-.1,0h0c-.3,0-.5-.2-.6-.5ZM355.4,368.4h0c0-.3.1-.7.5-.7h0c.3,0,.7.1.7.5h0c0,.3-.1.7-.5.7h0s0,0-.1,0h0c-.3,0-.5-.2-.6-.5ZM354.5,364.9c0-.3,0-.7.4-.7h0c.3,0,.7.1.7.4h0c0,.3-.1.7-.4.7h0c0,0-.1,0-.2,0h0c-.3,0-.5-.2-.6-.4ZM353.5,361.4h0c-.1-.3,0-.7.4-.8h0c.3-.1.7,0,.8.4h0c.1.3,0,.7-.4.8h0c0,0-.1,0-.2,0h0c-.3,0-.5-.2-.6-.4ZM352.3,358c-.1-.3,0-.7.4-.8h0c.3-.1.7,0,.8.4h0c.1.3,0,.7-.4.8h0c0,0-.1,0-.2,0h0c-.2,0-.5-.2-.6-.4ZM351,354.6h0c-.1-.3,0-.7.3-.8h0c.3-.1.7,0,.8.3h0c.1.3,0,.7-.3.8h0c0,0-.2,0-.2,0h0c-.2,0-.5-.1-.6-.4ZM349.5,351.3c-.1-.3,0-.7.3-.8h0c.3-.1.7,0,.8.3h0c.1.3,0,.7-.3.8h0c0,0-.2,0-.3,0h0c-.2,0-.4-.1-.5-.3ZM347.9,348h0c-.2-.3,0-.7.3-.8h0c.3-.2.7,0,.8.3h0c.2.3,0,.7-.3.8h0c0,0-.2,0-.3,0h0c-.2,0-.4-.1-.5-.3ZM346.1,344.9h0c-.2-.3,0-.7.2-.8h0c.3-.2.7,0,.8.2h0c.2.3,0,.7-.2.8h0c0,0-.2,0-.3,0h0c-.2,0-.4-.1-.5-.3ZM344.2,341.8c-.2-.3-.1-.7.2-.8h0c.3-.2.7,0,.8.2h0c.2.3,0,.7-.2.8h0c-.1,0-.2,0-.3,0h0c-.2,0-.4,0-.5-.3ZM342.2,338.8h0c-.2-.3-.1-.7.1-.8h0c.3-.2.7-.1.8.1h0c.2.3.1.7-.1.8h0c-.1,0-.2.1-.3.1h0c-.2,0-.4,0-.5-.3ZM340,335.8c-.2-.3-.2-.7.1-.9h0c.3-.2.6-.2.9.1h0c.2.3.2.6-.1.9h0c-.1,0-.2.1-.4.1h0c-.2,0-.4,0-.5-.2ZM337.7,333c-.2-.3-.2-.6,0-.9h0c.3-.2.6-.2.9,0h0c.2.3.2.6,0,.9h0c-.1,0-.2.1-.4.1h0c-.2,0-.3,0-.5-.2ZM335.3,330.3c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.2.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.5-.2ZM332.8,327.7c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.2.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.4-.2ZM332.8,327.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M333,327.5c-33-33-86.7-33-119.7,0l-.4-.4c33.2-33.2,87.3-33.2,120.5,0l-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M212.9,447.6c-33.2-33.2-33.2-87.3,0-120.6l.4.4c-33,33-33,86.7,0,119.7l-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M190.2,137.5c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7.8-1.7,1.7-1.7,1.7.8,1.7,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M115.8,179.8l-.5-.3c15.1-26.1,43.2-42.3,73.3-42.3v.6c-29.9,0-57.8,16.1-72.7,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M114.2,264.7c-7.5-13-11.5-27.8-11.5-42.9s4-29.9,11.5-42.9l2.6,1.5c-7.2,12.5-11.1,26.8-11.1,41.4s3.8,28.9,11.1,41.4l-2.6,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M188.5,307.3v-2.4c29.6,0,57.1-15.9,72-41.5l2.1,1.2c-15.3,26.4-43.6,42.8-74.1,42.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M261.8,264.1l-.5-.3c7.4-12.7,11.2-27.2,11.2-42s-3.9-29.3-11.2-42l.5-.3c7.4,12.8,11.3,27.4,11.3,42.3s-3.9,29.5-11.3,42.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M187.9,306.7c-.3,0-.6-.3-.6-.6h0c0-.3.3-.6.6-.6h0c.3,0,.6.3.6.6h0c0,.3-.3.6-.6.6h0ZM184.2,306.6c-.3,0-.6-.3-.6-.6h0c0-.3.3-.6.6-.6h0c.3,0,.6.3.6.6h0c0,.3-.3.6-.6.6h0ZM180.6,306.3c-.3,0-.6-.3-.5-.7h0c0-.3.3-.6.7-.6h0c.3,0,.6.3.5.7h0c0,.3-.3.6-.6.6h0ZM176.9,305.9h0c-.3,0-.6-.4-.5-.7h0c0-.3.4-.6.7-.5h0c.3,0,.6.4.5.7h0c0,.3-.3.5-.6.5h0s0,0,0,0ZM173.3,305.3h0c-.3,0-.6-.4-.5-.7h0c0-.3.4-.6.7-.5h0c.3,0,.6.4.5.7h0c0,.3-.3.5-.6.5h0s0,0-.1,0ZM169.7,304.6c-.3,0-.5-.4-.5-.7h0c0-.3.4-.5.7-.5h0c.3,0,.5.4.5.7h0c0,.3-.3.5-.6.5h0s0,0-.1,0ZM166.1,303.7c-.3,0-.5-.4-.4-.7h0c0-.3.4-.5.7-.4h0c.3,0,.5.4.4.7h0c0,.3-.3.5-.6.5h0s-.1,0-.2,0ZM162.6,302.7c-.3-.1-.5-.4-.4-.8h0c.1-.3.4-.5.8-.4h0c.3.1.5.4.4.8h0c0,.3-.3.4-.6.4h0c0,0-.1,0-.2,0ZM159.1,301.5h0c-.3-.1-.5-.5-.4-.8h0c.1-.3.5-.5.8-.4h0c.3.1.5.5.4.8h0c0,.2-.3.4-.6.4h0c0,0-.1,0-.2,0ZM155.7,300.1c-.3-.1-.5-.5-.3-.8h0c.1-.3.5-.5.8-.3h0c.3.1.5.5.3.8h0c0,.2-.3.4-.6.4h0c0,0-.2,0-.2,0ZM152.3,298.6c-.3-.1-.4-.5-.3-.8h0c.1-.3.5-.4.8-.3h0c.3.1.4.5.3.8h0c-.1.2-.3.3-.5.3h0c0,0-.2,0-.3,0ZM149,297c-.3-.2-.4-.5-.3-.8h0c.2-.3.5-.4.8-.3h0c.3.2.4.5.3.8h0c-.1.2-.3.3-.5.3h0c0,0-.2,0-.3,0ZM145.8,295.2c-.3-.2-.4-.5-.2-.8h0c.2-.3.5-.4.8-.2h0c.3.2.4.5.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3,0ZM142.7,293.3h0c-.3-.2-.4-.6-.2-.8h0c.2-.3.6-.4.8-.2h0c.3.2.4.6.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3,0ZM139.6,291.2c-.3-.2-.3-.6-.1-.8h0c.2-.3.6-.3.8-.1h0c.3.2.3.6.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.4-.1ZM136.7,289c-.3-.2-.3-.6-.1-.9h0c.2-.3.6-.3.9-.1h0c.3.2.3.6.1.9h0c-.1.2-.3.2-.5.2h0c-.1,0-.3,0-.4-.1ZM133.8,286.7h0c-.3-.2-.3-.6,0-.9h0c.2-.3.6-.3.9,0h0c.3.2.3.6,0,.9h0c-.1.1-.3.2-.5.2h0c-.1,0-.3,0-.4-.1ZM131.1,284.3c-.2-.2-.3-.6,0-.9h0c.2-.2.6-.3.9,0h0c.2.2.3.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.4-.2ZM128.4,281.7c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.2.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.4-.2ZM125.9,279.1c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.2.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.5-.2ZM123.4,276.3h0c-.2-.3-.2-.6,0-.9h0c.3-.2.6-.2.9,0h0c.2.3.2.6,0,.9h0c-.1,0-.2.1-.4.1h0c-.2,0-.3,0-.5-.2ZM121.1,273.4c-.2-.3-.2-.6.1-.9h0c.3-.2.7-.2.9.1h0c.2.3.2.6-.1.9h0c-.1,0-.2.1-.4.1h0c-.2,0-.4,0-.5-.2ZM119,270.5c-.2-.3-.1-.7.1-.8h0c.3-.2.7-.1.8.1h0c.2.3.1.7-.1.9h0c-.1,0-.2.1-.4.1h0c-.2,0-.4,0-.5-.3ZM116.9,267.4h0c-.2-.3-.1-.7.2-.8h0c.3-.2.7-.1.8.2h0c.2.3,0,.7-.2.8h0c-.1,0-.2,0-.3,0h0c-.2,0-.4,0-.5-.3ZM115,264.2c-.2-.3,0-.7.2-.8h0c.3-.2.7,0,.8.2h0c.2.3,0,.7-.2.8h0c0,0-.2,0-.3,0h0c-.2,0-.4-.1-.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M263.8,179.6c0,1.2-1,2.3-2.3,2.3s-2.3-1-2.3-2.3,1-2.3,2.3-2.3,2.3,1,2.3,2.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    cx: 272.8,
    cy: 221.8,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M190.3,306.1c0,1-.8,1.8-1.8,1.8s-1.8-.8-1.8-1.8.8-1.8,1.8-1.8,1.8.8,1.8,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M567.9,137.5c0,.9.8,1.7,1.7,1.7s1.7-.8,1.7-1.7-.8-1.7-1.7-1.7-1.7.8-1.7,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M641.5,180.2c-14.8-25.6-42.4-41.5-72-41.5v-2.4c30.4,0,58.8,16.4,74.1,42.8l-2.1,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M642.8,264.1l-.5-.3c7.4-12.7,11.2-27.2,11.2-42s-3.9-29.3-11.2-42l.5-.3c7.4,12.8,11.3,27.4,11.3,42.3s-3.9,29.5-11.3,42.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M569,306.1c0-.3.3-.6.6-.6h0c.3,0,.6.3.6.6h0c0,.3-.3.6-.6.6h0c-.3,0-.6-.3-.6-.6ZM565.9,306.6h0c-.3,0-.6-.3-.6-.6h0c0-.3.3-.6.6-.6h0c.3,0,.6.3.6.6h0c0,.3-.3.6-.6.6h0ZM562.2,306.4h0c-.3,0-.6-.3-.6-.7h0c0-.3.3-.6.7-.6h0c.3,0,.6.3.6.7h0c0,.3-.3.6-.6.6h0ZM558.6,306h0c-.3,0-.6-.3-.5-.7h0c0-.3.4-.6.7-.5h0c.3,0,.6.3.5.7h0c0,.3-.3.5-.6.5h0s0,0,0,0ZM554.9,305.4c-.3,0-.6-.4-.5-.7h0c0-.3.4-.6.7-.5h0c.3,0,.6.4.5.7h0c0,.3-.3.5-.6.5h0s0,0-.1,0ZM551.3,304.7c-.3,0-.5-.4-.5-.7h0c0-.3.4-.5.7-.5h0c.3,0,.5.4.5.7h0c0,.3-.3.5-.6.5h0s0,0-.1,0ZM547.7,303.9h0c-.3,0-.5-.4-.4-.7h0c0-.3.4-.5.7-.4h0c.3,0,.5.4.4.7h0c0,.3-.3.5-.6.5h0s-.1,0-.2,0ZM544.2,302.8c-.3,0-.5-.4-.4-.8h0c.1-.3.4-.5.8-.4h0c.3.1.5.4.4.8h0c0,.3-.3.4-.6.4h0c0,0-.1,0-.2,0ZM540.7,301.7h0c-.3-.1-.5-.5-.4-.8h0c.1-.3.5-.5.8-.4h0c.3.1.5.5.4.8h0c0,.2-.3.4-.6.4h0c0,0-.1,0-.2,0ZM537.2,300.3c-.3-.1-.5-.5-.3-.8h0c.1-.3.5-.5.8-.3h0c.3.1.5.5.3.8h0c0,.2-.3.4-.6.4h0c0,0-.2,0-.2,0ZM533.9,298.8c-.3-.1-.4-.5-.3-.8h0c.1-.3.5-.4.8-.3h0c.3.1.4.5.3.8h0c-.1.2-.3.4-.6.4h0c0,0-.2,0-.3,0ZM530.6,297.2c-.3-.2-.4-.5-.3-.8h0c.2-.3.5-.4.8-.3h0c.3.2.4.5.3.8h0c-.1.2-.3.3-.5.3h0c0,0-.2,0-.3,0ZM527.3,295.5c-.3-.2-.4-.5-.2-.8h0c.2-.3.5-.4.8-.2h0c.3.2.4.5.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3,0ZM524.2,293.6c-.3-.2-.4-.6-.2-.8h0c.2-.3.6-.4.8-.2h0c.3.2.4.6.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3,0ZM521.1,291.5c-.3-.2-.3-.6-.2-.8h0c.2-.3.6-.3.8-.2h0c.3.2.3.6.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3-.1ZM518.1,289.4c-.3-.2-.3-.6-.1-.9h0c.2-.3.6-.3.9-.1h0c.3.2.3.6.1.9h0c-.1.2-.3.2-.5.2h0c-.1,0-.3,0-.4-.1ZM515.3,287.1c-.3-.2-.3-.6,0-.9h0c.2-.3.6-.3.9,0h0c.3.2.3.6,0,.9h0c-.1.1-.3.2-.5.2h0c-.1,0-.3,0-.4-.1ZM512.5,284.6c-.2-.2-.3-.6,0-.9h0c.2-.2.6-.3.9,0h0c.2.2.3.6,0,.9h0c-.1.1-.3.2-.5.2h0c-.1,0-.3,0-.4-.2ZM509.8,282.1h0c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.2.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.4-.2ZM507.2,279.5c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.2.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.4-.2ZM504.8,276.7c-.2-.3-.2-.6,0-.9h0c.3-.2.6-.2.9,0h0c.2.3.2.6,0,.9h0c-.1,0-.2.1-.4.1h0c-.2,0-.3,0-.5-.2ZM502.5,273.8h0c-.2-.3-.2-.6.1-.9h0c.3-.2.6-.2.9.1h0c.2.3.2.6-.1.9h0c-.1,0-.2.1-.4.1h0c-.2,0-.4,0-.5-.2ZM500.3,270.9c-.2-.3-.1-.7.1-.9h0c.3-.2.7-.1.8.1h0c.2.3.1.7-.1.8h0c-.1,0-.2.1-.3.1h0c-.2,0-.4,0-.5-.3ZM498.2,267.9c-.2-.3-.1-.7.2-.8h0c.3-.2.7-.1.8.2h0c.2.3.1.7-.2.8h0c-.1,0-.2.1-.3.1h0c-.2,0-.4-.1-.5-.3ZM496.3,264.7c-.2-.3,0-.7.2-.8h0c.3-.2.7,0,.8.2h0c.2.3,0,.7-.2.8h0c0,0-.2,0-.3,0h0c-.2,0-.4-.1-.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M496.3,264.1c-7.4-12.8-11.3-27.4-11.3-42.3s3.9-29.5,11.3-42.3l.5.3c-7.4,12.7-11.2,27.2-11.2,42s3.9,29.3,11.2,42l-.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M569.6,306.2v-.3c15,0,29.8-4,42.7-11.6,12.5-7.4,23-17.9,30.2-30.5l.3.2c-7.3,12.6-17.8,23.2-30.3,30.6-12.9,7.6-27.7,11.6-42.8,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M494.3,179.6c0,1.2,1,2.3,2.3,2.3s2.3-1,2.3-2.3-1-2.3-2.3-2.3-2.3,1-2.3,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M483.2,221.8c0,1.1.9,2,2,2s2-.9,2-2-.9-2-2-2-2,.9-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M567.8,306.1c0,1,.8,1.8,1.8,1.8s1.8-.8,1.8-1.8-.8-1.8-1.8-1.8-1.8.8-1.8,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M642.6,186.5c-3.7,0-6.7-3-6.7-6.7s3-6.7,6.7-6.7,6.7,3,6.7,6.7-3,6.7-6.7,6.7ZM642.6,173.5c-3.5,0-6.4,2.9-6.4,6.4s2.9,6.4,6.4,6.4,6.4-2.9,6.4-6.4-2.9-6.4-6.4-6.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    cx: 642.6,
    cy: 179.8,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    cx: 642.5,
    cy: 263.9,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    x: 334,
    y: 275.7,
    width: 151.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    x: 305.4,
    y: 275.1,
    width: 28.6,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    x: 272.6,
    y: 276.1,
    width: 32.8,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    x: 272.1,
    y: 223.9,
    width: 1.2,
    height: 78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    cx: 272.7,
    cy: 302.3,
    r: 1.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    points: "330.4 327.2 333.5 324.4 335.3 329.4 330.4 327.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    cx: 272.8,
    cy: 276.3,
    r: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    x: 484.9,
    y: 221.3,
    width: 0.6,
    height: 65.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M486.4,276.4c0,.7-.5,1.2-1.2,1.2s-1.2-.5-1.2-1.2.5-1.2,1.2-1.2,1.2.5,1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M486.4,270.4c0,.7-.5,1.2-1.2,1.2s-1.2-.5-1.2-1.2.5-1.2,1.2-1.2,1.2.5,1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M485.2,473.4c-22.1,0-44.1-8.4-60.9-25.2l1.7-1.7c32.6,32.6,85.8,32.6,118.4,0l1.7,1.7c-16.8,16.8-38.9,25.2-60.9,25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M546.2,446.5c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.2.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.4-.2ZM548.7,443.8c-.3-.2-.3-.6,0-.9h0c.2-.3.6-.3.9,0h0c.2.2.3.6,0,.9h0c-.1.1-.3.2-.5.2h0c-.1,0-.3,0-.4-.2ZM551,441c-.3-.2-.3-.6,0-.9h0c.2-.3.6-.3.9,0h0c.3.2.3.6,0,.9h0c-.1.2-.3.2-.5.2h0c-.1,0-.3,0-.4-.1ZM553.3,438.1c-.3-.2-.3-.6-.1-.9h0c.2-.3.6-.3.9-.1h0c.3.2.3.6.1.9h0c-.1.2-.3.2-.5.2h0c-.1,0-.2,0-.4-.1ZM555.4,435.2c-.3-.2-.4-.6-.2-.8h0c.2-.3.6-.4.8-.2h0c.3.2.4.6.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3-.1ZM557.4,432.1c-.3-.2-.4-.5-.2-.8h0c.2-.3.6-.4.8-.2h0c.3.2.4.5.2.8h0c-.1.2-.3.3-.5.3h0c-.1,0-.2,0-.3,0ZM559.3,429c-.3-.2-.4-.5-.2-.8h0c.2-.3.5-.4.8-.2h0c.3.2.4.5.2.8h0c-.1.2-.3.3-.5.3h0c0,0-.2,0-.3,0ZM561,425.7c-.3-.2-.4-.5-.3-.8h0c.2-.3.5-.4.8-.3h0c.3.1.4.5.3.8h0c-.1.2-.3.3-.5.3h0c0,0-.2,0-.3,0ZM562.6,422.5c-.3-.1-.4-.5-.3-.8h0c.1-.3.5-.4.8-.3h0c.3.1.4.5.3.8h0c-.1.2-.3.4-.6.4h0c0,0-.2,0-.2,0ZM564,419.1c-.3-.1-.5-.5-.3-.8h0c.1-.3.5-.5.8-.3h0c.3.1.5.5.3.8h0c0,.2-.3.4-.6.4h0c0,0-.2,0-.2,0ZM565.3,415.7c-.3-.1-.5-.5-.4-.8h0c.1-.3.5-.5.8-.4h0c.3.1.5.5.4.8h0c0,.2-.3.4-.6.4h0c0,0-.1,0-.2,0ZM566.4,412.2c-.3,0-.5-.4-.4-.8h0c0-.3.4-.5.8-.4h0c.3,0,.5.4.4.8h0c0,.3-.3.4-.6.4h0c0,0-.1,0-.2,0ZM567.4,408.7c-.3,0-.5-.4-.4-.7h0c0-.3.4-.5.7-.4h0c.3,0,.5.4.4.7h0c0,.3-.3.5-.6.5h0s0,0-.1,0ZM568.3,405.1c-.3,0-.5-.4-.5-.7h0c0-.3.4-.5.7-.5h0c.3,0,.5.4.5.7h0c0,.3-.3.5-.6.5h0s0,0-.1,0ZM569,401.5c-.3,0-.6-.4-.5-.7h0c0-.3.4-.6.7-.5h0c.3,0,.6.4.5.7h0c0,.3-.3.5-.6.5h0s0,0,0,0ZM569.5,397.9c-.3,0-.6-.3-.5-.7h0c0-.3.3-.6.7-.5h0c.3,0,.6.3.5.7h0c0,.3-.3.5-.6.5h0s0,0,0,0ZM569.9,394.3c-.3,0-.6-.3-.6-.7h0c0-.3.3-.6.7-.6h0c.3,0,.6.3.6.7h0c0,.3-.3.6-.6.6h0s0,0,0,0ZM570.1,390.6c-.3,0-.6-.3-.6-.6h0c0-.3.3-.6.6-.6h0c.3,0,.6.3.6.6h0c0,.3-.3.6-.6.6h0ZM569.5,386.4c0-.3.3-.6.6-.6h0c.3,0,.6.3.6.6h0c0,.3-.3.6-.6.6h0c-.3,0-.6-.3-.6-.6ZM569.4,382.8h0c0-.3.2-.6.6-.6h0c.3,0,.6.2.6.6h0c0,.3-.2.6-.6.6h0c-.3,0-.6-.2-.6-.6ZM569.2,379.1h0c0-.3.2-.6.5-.7h0c.3,0,.6.2.7.5h0c0,.3-.2.6-.5.7h0s0,0,0,0h0c-.3,0-.6-.2-.6-.5ZM568.7,375.5c0-.3.2-.6.5-.7h0c.3,0,.6.2.7.5h0c0,.3-.2.6-.5.7h0s0,0,0,0h0c-.3,0-.6-.2-.6-.5ZM568.1,372h0c0-.3.2-.6.5-.7h0c.3,0,.6.2.7.5h0c0,.3-.2.6-.5.7h0s0,0-.1,0h0c-.3,0-.5-.2-.6-.5ZM567.4,368.4h0c0-.3.1-.7.5-.7h0c.3,0,.7.1.7.5h0c0,.3-.1.7-.5.7h0s0,0-.1,0h0c-.3,0-.5-.2-.6-.5ZM566.5,364.9h0c0-.3.1-.7.4-.7h0c.3,0,.7.1.7.4h0c0,.3-.1.7-.4.7h0c0,0-.1,0-.2,0h0c-.3,0-.5-.2-.6-.4ZM565.5,361.4h0c-.1-.3,0-.7.4-.8h0c.3-.1.7,0,.8.4h0c.1.3,0,.7-.4.8h0c0,0-.1,0-.2,0h0c-.3,0-.5-.2-.6-.4ZM564.3,358h0c-.1-.3,0-.7.4-.8h0c.3-.1.7,0,.8.4h0c.1.3,0,.7-.4.8h0c0,0-.1,0-.2,0h0c-.2,0-.5-.2-.6-.4ZM563,354.6c-.1-.3,0-.7.3-.8h0c.3-.1.7,0,.8.3h0c.1.3,0,.7-.3.8h0c0,0-.2,0-.2,0h0c-.2,0-.5-.1-.6-.4ZM561.5,351.3c-.1-.3,0-.7.3-.8h0c.3-.1.7,0,.8.3h0c.1.3,0,.7-.3.8h0c0,0-.2,0-.3,0h0c-.2,0-.4-.1-.5-.3ZM559.9,348c-.2-.3,0-.7.3-.8h0c.3-.2.7,0,.8.3h0c.2.3,0,.7-.3.8h0c0,0-.2,0-.3,0h0c-.2,0-.4-.1-.5-.3ZM558.1,344.9c-.2-.3,0-.7.2-.8h0c.3-.2.7,0,.8.2h0c.2.3,0,.7-.2.8h0c0,0-.2,0-.3,0h0c-.2,0-.4-.1-.5-.3ZM556.2,341.8h0c-.2-.3-.1-.7.2-.8h0c.3-.2.7,0,.8.2h0c.2.3,0,.7-.2.8h0c-.1,0-.2,0-.3,0h0c-.2,0-.4,0-.5-.3ZM554.2,338.8c-.2-.3-.1-.7.1-.8h0c.3-.2.7-.1.8.1h0c.2.3.1.7-.1.8h0c-.1,0-.2.1-.3.1h0c-.2,0-.4,0-.5-.3ZM552,335.8h0c-.2-.3-.2-.7.1-.9h0c.3-.2.6-.2.9.1h0c.2.3.2.6-.1.9h0c-.1,0-.2.1-.4.1h0c-.2,0-.4,0-.5-.2ZM549.8,333c-.2-.3-.2-.6,0-.9h0c.3-.2.6-.2.9,0h0c.2.3.2.6,0,.9h0c-.1,0-.3.1-.4.1h0c-.2,0-.3,0-.5-.2ZM547.4,330.3c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.2.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.5-.2ZM544.8,327.7h0c-.2-.2-.2-.6,0-.9h0c.2-.2.6-.2.9,0h0c.2.2.2.6,0,.9h0c-.1.1-.3.2-.4.2h0c-.2,0-.3,0-.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M544.4,328.1c-32.6-32.6-85.8-32.6-118.4,0l-1.7-1.7c33.6-33.6,88.2-33.6,121.8,0l-1.7,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M424.9,447.6c-33.2-33.2-33.2-87.3,0-120.6l.4.4c-33,33-33,86.7,0,119.7l-.4.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    points: "483.2 286.6 487.3 286.6 485.3 291.5 483.2 286.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    points: "483.2 292.4 487.3 292.4 485.3 297.3 483.2 292.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    cx: 485.4,
    cy: 301.1,
    r: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    x: 431.7,
    y: 268.9,
    width: 0.3,
    height: 8.3,
    transform: "translate(-66.6 385.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M427.7,270.1c0-.2.1-.3.3-.3h0c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3h0c-.2,0-.3-.1-.3-.3ZM425.9,270.1c0-.2.1-.3.3-.3h0c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3h0c-.2,0-.3-.1-.3-.3ZM424,270.1c0-.2.1-.3.3-.3h0c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3h0c-.2,0-.3-.1-.3-.3ZM422.2,270.1c0-.2.1-.3.3-.3h0c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3h0c-.2,0-.3-.1-.3-.3ZM420.4,270.1c0-.2.1-.3.3-.3h0c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3h0c-.2,0-.3-.1-.3-.3ZM418.6,270.1c0-.2.1-.3.3-.3h0c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3h0c-.2,0-.3-.1-.3-.3ZM416.7,270.1c0-.2.1-.3.3-.3h0c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3h0c-.2,0-.3-.1-.3-.3ZM414.9,270.1c0-.2.1-.3.3-.3h0c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3h0c-.2,0-.3-.1-.3-.3ZM413.1,270.1c0-.2.1-.3.3-.3h0c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3h0c-.2,0-.3-.1-.3-.3ZM411.2,270.1c0-.2.1-.3.3-.3h0c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3h0c-.2,0-.3-.1-.3-.3ZM409.4,270.1c0-.2.1-.3.3-.3h0c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3h0c-.2,0-.3-.1-.3-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    x: 393.7,
    y: 276.6,
    width: 18.8,
    height: 0.3,
    transform: "translate(-77.6 366.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    x: 378.4,
    y: 283.1,
    width: 18,
    height: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M410.6,270.1c0,.5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    d: "M429.8,270.1c0,.5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-538d5a85-7a77-4c89-a5cb-19459946ce0f",
    cx: 378.5,
    cy: 283.4,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0ba2a92d-6071-4eda-9bb7-1aebfe869771",
    d: "M427.9,219.3v-6.6h-96.1v6.6h0c0,1.3,21.5,2.4,48.1,2.4s48.1-1.1,48.1-2.4h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-62be9ac4-d1e8-4431-af78-13486ffb2dc9",
    cx: 379.9,
    cy: 212.7,
    rx: 48.1,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9d2f3c92-885f-4e69-a317-ed525422d31a",
    d: "M337.4,198.2h0v14.5s0,0,0,0c0,.7,19,1.4,42.5,1.4s42.5-.6,42.5-1.4v-14.5h-84.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-a2f6ca68-06e6-4ca1-b843-5b2d1633141f",
    cx: 379.9,
    cy: 198.2,
    rx: 42.5,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ec085305-72e8-4d9a-8dff-59ca80e16cc2",
    d: "M379.9,202.8c-6,0-11.6,0-16.5-.1v8c1,0,2,0,3,0,4.2,0,8.7,0,13.5,0s9.4,0,13.5,0c1,0,2,0,3,0v-8c-4.9,0-10.5.1-16.5.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-b890e116-46a0-4576-bdde-aa989450a094",
    cx: 364.9,
    cy: 204,
    rx: 0.5,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-91107ac9-188d-48f1-8090-dfb5fa821614",
    d: "M365.4,209.5c0,.2-.2.4-.5.4s-.5-.2-.5-.4.2-.4.5-.4c.3,0,.5.2.5.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-a7deae4d-b881-46d2-859a-e9e2e2b974fe",
    cx: 394.8,
    cy: 204,
    rx: 0.5,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b7c669bf-a446-4474-b345-4ca2e7289cc0",
    d: "M395.2,209.5c0,.2-.2.4-.5.4s-.5-.2-.5-.4.2-.4.5-.4c.3,0,.5.2.5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-deededdd-919a-4827-8ac2-84525afd6615",
    d: "M344.7,98.3v100.1h70.3v-100.1h-70.3ZM414,197.4h-68.4v-98.1h68.4v98.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-652e3418-311d-4d10-9d2c-9d05c27c87ee",
    points: "345.7 197.4 414 197.4 414 99.3 345.7 99.3 345.7 197.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-12478e0d-e418-4c83-bf57-524611b76b41",
    points: "350.2 192.9 350.2 103.8 409.5 103.8 409.5 192.9 350.2 192.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-7766015f-2911-4eca-a04d-9866afa2304d",
    points: "543.4 285.2 538.5 281.7 533.5 285.2 533.5 271.6 543.4 271.6 543.4 285.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a57ba21b-7790-4d7f-989b-1a2a0355870e",
    x: 533.5,
    y: 271.6,
    width: 9.9,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    x: 519,
    y: 159.4,
    width: 79.3,
    height: 117.3,
    rx: 5.1,
    ry: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-13e14e2d-a036-460d-b35a-d1cb972d5a17",
    d: "M592.9,274.5h-66.7c-2.8,0-5.1-2.3-5.1-5.1v-104.7c0-1.1.4-2.1,1-2.9-1.3.9-2.1,2.4-2.1,4.1v104.7c0,2.8,2.3,5.1,5.1,5.1h66.7c1.7,0,3.1-.8,4.1-2.1-.8.6-1.8,1-2.9,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ef529fd9-ce42-481c-be87-753d4e985d61",
    d: "M592.5,160.8h-67c-1.9,0-3.6,1.1-4.4,2.8.6-.3,1.4-.5,2.1-.5h67c2.7,0,4.9,2.2,4.9,4.9v103.8c0,.8-.2,1.5-.5,2.1,1.6-.8,2.8-2.5,2.8-4.4v-103.8c0-2.7-2.2-4.9-4.9-4.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-ca3cafad-d740-4a9d-aba6-eefe2077f3c9",
    x: 578.8,
    y: 159.4,
    width: 4.5,
    height: 117.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.9,
    y: 159.4,
    width: 0.2,
    height: 117.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.4,
    y: 159.4,
    width: 0.2,
    height: 117.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.8,
    y: 159.4,
    width: 0.2,
    height: 117.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580.2,
    y: 159.4,
    width: 0.2,
    height: 117.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580.7,
    y: 159.4,
    width: 0.2,
    height: 117.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.1,
    y: 159.4,
    width: 0.2,
    height: 117.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.6,
    y: 159.4,
    width: 0.2,
    height: 117.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582,
    y: 159.4,
    width: 0.2,
    height: 117.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.5,
    y: 159.4,
    width: 0.2,
    height: 117.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.9,
    y: 159.4,
    width: 0.2,
    height: 117.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.1,204.3c-.9.7-1.8,1-2.9.8-2.4-.3-1.6-3.1,1.1-2.1.4.2,1.4.7,1.8.9,1.7-1.7,2.6-4.9,4.5-6.9-1.2-.7-2.6-1-4-.7-3.3.7-4.2,3.6-2.5,4.1,1.4.4,2.1-.9,2.1-1.3,0-.1.3-.1.2.1-.2,1.2-1.4,1.8-2.5,1.5-2.1-.7-2-4.1,2.9-4.8,1.4-.2,2.9,0,4.1.7.6-.7,1.2-1.1,1.5-1.1.2,0,0,.2,0,.2-.3,0-.9,1-1,1.2,1.6,1.1,2.6,2.8,2.4,5-.4,3.7-5.2,3.7-7.6,2.4ZM547.9,203.3c-1.7-.6-1.9,1.4-.5,1.5.8,0,1.6-.2,2.2-.7-.6-.3-1.1-.6-1.8-.8ZM555,197.3c-1.4,2.2-2.9,5-4.2,6.4-.2.2-.3.3-.4.4,2.3,1.4,6.3.9,6.6-2.2.2-1.9-.6-3.6-2-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.6,204.5c.2,0,.4-.1.5-.2.4-.4.8-1.1,1.1-1.8,0-.2.3-.1.2.1-.3.7-1,2.2-1.8,2.2s-.9-.9-.6-1.5l.7-1.9c0-.2,0-.4-.1-.5h.6c.4,0,.4.1.2.4l-.9,2.2s-.1.3-.1.3c-.1.4,0,.7.2.7ZM559.5,200.3c-.3,0-.4-.2-.4-.5,0-.3.3-.5.6-.5s.5.2.4.5c0,.3-.3.5-.6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.8,204.8c-.4,0-.9-.3-.6-1.5-.2.3-.5.8-.8,1.1-1.4,1.3-2.2-.8-.5-2.9.7-.8,2.1-1.3,2.7-.5.2.2,0,.4-.1.3-.1-.4-.6-.5-1-.3-.5.3-1.1,1-1.6,1.7,0,.2-.4.7-.5,1.2-.1.8.5.7,1.1,0,.4-.5.7-1.1,1-1.6.3-.5.4-.8.8-.7.2,0,.3,0,.5,0-.2.2-.9,1.5-1.1,2.2,0,.5,0,.7.1.7.5,0,1.3-1.5,1.5-2,.1-.2.3-.1.2,0-.4.7-1.1,2.1-1.8,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.9,204.7c-.4,0-1.1-.3-.6-1.5.2-.5.6-1.1.7-1.4.2-.4-.2-.5-.9-.6v.4c-.4.7-1,2-1.6,2.6,0,0-.2,0,0-.2.9-1.2,1.6-3,1.8-4.3.1-.7.9-.4.7.4,0,.3-.4.6-.6.8.4,0,1,0,1.6,0,0,.2-.1.6-.2.9-.2.4-1.4,2.5-.7,2.5.5,0,1.2-1.5,1.5-2,.1-.2.3-.1.1.1-.3.7-.9,2-1.7,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.5,205.3c-.7,1.3-1.9,3.1-3.6,3.1s-1.3-.8-.9-1.4c.2-.4.6-.7,1.1-1,.8-.4,1.9-.6,2.9-.8.4-.8.8-2,1-2.6-.4.7-1.2,2.2-2.1,2.2s-.6,0-.7-.5c-.1-.5.2-.9.4-1.4,0,0-.2,0-.1-.2l.2-.4c.2-.4.5-.9.7-1.3,0-.2.2-.2.5-.2h.7c-.1,0-.3.2-.4.4-.4.7-.7,1.4-1.1,2.1-.6,1.2,0,1.7.7.8.7-.8,1.4-2.1,1.8-3.1,0-.2.2-.2.5-.2h.6c-.4.3-.6.8-.9,1.6-.3.8-.6,1.8-.9,2.7.5-.1,1.2-.5,1.7-1.2.4-.5.6-1.1.7-1.3.1-.2.3-.1.2.1-.8,1.6-1.1,2.1-2.8,2.7ZM566.2,206.3c-1.2.5-1.6,1.9-.6,1.9s2.3-1.5,2.8-2.2l.3-.4c-.8.2-1.8.4-2.4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.7,202.2c0,.3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.6,202.2c0,.3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-8ea17490-a4de-462e-94e9-e0f14cd0fe83",
    d: "M148.9,221c-.4,0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7M148.6,201.9c-.4-2.6-.9-5.1-1.3-7.6-.9-5.1-1.8-10.3-2.5-15.5-.5-4.1-1.5-11.6.8-15.7,1.2-2.2,3.1-3.5,4.9-3.5s3.2,1.2,4.1,3.4c2.9,7.1-1.2,19.6-2.8,24.3-.1.3-2.2,6.1-3.3,14.6M150.6,157.6c-2.6,0-5.1,1.8-6.7,4.6-2.6,4.7-1.6,12.3-1,16.9.7,5.2,1.6,10.5,2.5,15.6.9,5.1,1.8,10.4,2.5,15.7h-1.6v8.6h.5v2.5h-20.2v30.5h1.7s40.8,0,40.8,0h0s.2,0,.2,0h1.5v-30.5h-19.7v-2.5h.5v-8.6h-1.6c.4-12.6,3.9-22.3,3.9-22.4,2.8-8.4,5.5-18.8,2.7-25.7-1.2-2.9-3.4-4.6-5.9-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M148,210.2h-2v-1.3c-.7-5.4-1.6-10.7-2.5-15.9-.9-5.1-1.8-10.4-2.5-15.6-.6-4.6-1.5-12.3,1-16.9,1.6-2.8,4.1-4.6,6.7-4.6s4.7,1.7,5.9,4.6c2.8,6.9,0,17.3-2.7,25.7,0,.1-3.8,10.7-3.9,24ZM148.8,157.9c-1.8,0-3.7,1.4-4.9,3.5-2.3,4.1-1.3,11.6-.8,15.7.6,5.1,1.6,10.4,2.5,15.5.4,2.5.9,5,1.3,7.6,1.1-8.5,3.2-14.3,3.3-14.6,1.5-4.7,5.7-17.2,2.8-24.3-.9-2.2-2.4-3.4-4.1-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M167.2,219.7h-40.8c-.9,0-1.7.8-1.7,1.7v27.1c0,.9.8,1.7,1.7,1.7h40.8c.9,0,1.7-.8,1.7-1.7v-27.1c0-.9-.8-1.7-1.7-1.7ZM150.8,222.7h-8c-.3,0-.6-.3-.6-.6s.3-.6.6-.6h8c.3,0,.6.3.6.6,0,.3-.3.6-.6.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    x: 127.5,
    y: 224.9,
    width: 38.6,
    height: 22.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-948682f5-4743-463a-a44f-3033288056aa",
    d: "M144.8,217.3v5.4h4.4v-5.4h-4.4ZM147,219.4c-.4,0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7c0,.4-.3.7-.7.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-67871640-bc58-48e5-853a-79e545001da8",
    x: 144.4,
    y: 208.7,
    width: 5.3,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-67871640-bc58-48e5-853a-79e545001da8",
    x: 130.2,
    y: 242.6,
    width: 21.2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-67871640-bc58-48e5-853a-79e545001da8",
    x: 153.2,
    y: 242.6,
    width: 10.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-67871640-bc58-48e5-853a-79e545001da8",
    x: 130.2,
    y: 244.4,
    width: 8.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-67871640-bc58-48e5-853a-79e545001da8",
    x: 139.6,
    y: 244.4,
    width: 8,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-67871640-bc58-48e5-853a-79e545001da8",
    x: 148.4,
    y: 244.4,
    width: 14.9,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-67871640-bc58-48e5-853a-79e545001da8",
    x: 152.3,
    y: 227.5,
    width: 11.1,
    height: 13.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    points: "133.2 240.4 133 240.4 133 239.8 133 239.8 133 239.8 132.9 239.8 132.9 240.4 133 240.4 133.2 240.4 133.2 240.4 133.2 240.4 133.2 240.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M133.4,239.8c0,0-.2,0-.2.2v.4c0,0,0,.2.2.2s.2,0,.2-.2v-.4c0,0,0-.2-.2-.2ZM133.5,240.3h0c0,0,0,0,0,0v-.4h0c0,0,0,0,0,0v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M133.8,239.8h-.2v.7h0s0,0,0,0h0v-.3h.1v.3h0s0,0,0,0h0v-.2h0c0-.1,0-.2,0-.2h0c0-.2,0-.2-.2-.2ZM133.9,240h0c0,0,0,0,0,0v-.2h.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    points: "134.3 239.8 134.1 239.8 134.1 239.8 134.1 240.4 134.1 240.4 134.3 240.4 134.3 240.4 134.3 240.4 134.3 240.4 134.2 240.4 134.2 240.1 134.3 240.1 134.3 240.1 134.3 240.1 134.3 240.1 134.2 240.1 134.2 239.8 134.3 239.8 134.3 239.8 134.3 239.8 134.3 239.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M134.8,239.8h-.1c0,0-.1,0-.1,0,0,0-.2,0-.2.2v.5h0s0,0,0,0h0v-.5h0c0,0,0,0,0,0v.5h0s0,0,0,0h0v-.5h0c0,0,0,0,0,0v.5h0s0,0,0,0h0v-.5c0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    points: "135.4 239.8 135.3 239.8 135.3 239.8 135.3 240.4 135.3 240.4 135.4 240.4 135.4 240.4 135.4 239.8 135.4 239.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M135.7,239.8h-.2v.3h0v.4h0s0,0,0,0h0v-.3h0c0,0,.2,0,.2-.2h0c0-.2,0-.2-.2-.2ZM135.8,240h0c0,0,0,0,0,0v-.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M136.1,239.8c0,0-.2,0-.2.2h0c0,0,.2.3.2.3h0s0,0,0,0h0c0-.1,0-.1,0-.1h0c0,.2,0,.2.2.2s.2,0,.2-.2h0c0,0-.2-.3-.2-.3h0s0,0,0,0h0c0,.1,0,.1,0,.1h0c0-.2,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M136.6,239.8h0v.5h0c0,0,0,0,0,0v-.5h0s0,0,0,0h0v.5c0,0,0,.2.2.2s.2,0,.2-.2v-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M137.2,239.8h-.1c0,0-.1,0-.1,0,0,0-.2,0-.2.2v.5h0s0,0,0,0h0v-.5h0c0,0,0,0,0,0v.5h0s0,0,0,0h0v-.5h0c0,0,0,0,0,0v.5h0s0,0,0,0h0v-.5c0,0,0-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    points: "132.3 237.7 131.9 237.7 131.9 239.4 132.8 239.4 132.8 239.1 132.3 239.1 132.3 237.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M133.9,237.9c0,0-.1-.1-.2-.2,0,0-.2,0-.3,0s-.2,0-.3,0c0,0-.1,0-.2.2,0,0,0,.1,0,.2,0,0,0,.2,0,.5s0,.4,0,.5c0,0,0,.2,0,.2,0,0,.1.1.2.2,0,0,.2,0,.3,0s.2,0,.3,0c0,0,.1,0,.2-.2,0,0,0-.1,0-.2,0,0,0-.2,0-.5s0-.4,0-.5c0,0,0-.2,0-.2ZM133.6,238.7c0,.2,0,.3,0,.4h-.1c0,0-.1,0-.1,0,0,0,0-.2,0-.4v-.3c0-.2,0-.3,0-.4h.1c0,0,.1,0,.1,0,0,0,0,.2,0,.4v.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M135.4,239h0c0-.2,0-.3-.2-.4l.2-.2c0,0,0-.2,0-.2s0-.2,0-.2h-.1c0-.1-.2-.2-.2-.2,0,0-.2,0-.3,0h-.5v1.7h.4v-.7h.2c0,0,0,.2,0,.3h0c0,0,0,.2,0,.2h0c0,.1,0,.2,0,.2h.5c0,0,0-.2,0-.4h0ZM134.9,238.4s0,0-.2,0h0s0,0,0,0v-.4h0s0,0,0,0c0,0,.1,0,.2,0v.2c0,0,0,.1,0,.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    points: "136.6 238 136.6 237.7 135.6 237.7 135.6 239.4 136.6 239.4 136.6 239.1 136 239.1 136 238.7 136.5 238.7 136.5 238.4 136 238.4 136 238 136.6 238"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M137.7,238.4s0,0,0,.2c0,0,0,.2,0,.2,0,0,0-.2,0-.3,0,0,0-.1,0-.1l-.2-.7h-.6v1.7h.4v-1.3s.2,1.3.2,1.3h.3l.3-1.3v1.3s.3,0,.3,0v-1.7h-.6l-.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M135.2,227.3c-2.7,0-5,2.2-5,5s2.2,5,5,5,5-2.2,5-5c0-2.7-2.2-5-5-5ZM139.7,232c-.3-.3-1.2-1.2-2.4-1.2s-.7,0-1,.2c.1-.3.2-.7.2-1,0-1.1-.8-2-1.2-2.4,2.3.1,4.2,2,4.3,4.3ZM139.5,232.3c-.3.3-1.1,1.1-2.1,1.1s-1-.2-1.5-.6c-.2-.2-.3-.3-.4-.4.2-.2.4-.4.5-.5.5-.4.9-.5,1.4-.5,1,0,1.8.8,2.1,1.1ZM135.2,228c.3.3,1.1,1.1,1.1,2.1,0,.5-.2,1-.5,1.4-.2.1-.4.3-.5.5-.1-.1-.3-.3-.4-.4-.4-.5-.6-1-.6-1.5,0-1,.8-1.8,1.1-2.1ZM134.9,232.3c0,0-.2.2-.3.3-.4.3-1,.8-1.8.8s-1.4-.4-2-1.1c.6-.7,1.3-1.1,2-1.1s1.3.3,1.7.7c.1.1.3.3.4.4ZM134.9,227.7c-.3.3-1.2,1.2-1.2,2.4,0,.4,0,.7.2,1.1-.3-.2-.7-.3-1.2-.3-.8,0-1.5.4-2.2,1.2.1-2.3,2-4.2,4.3-4.3ZM130.6,232.6c.7.8,1.4,1.2,2.2,1.2s.9-.1,1.2-.3c-.2.4-.3.8-.3,1.2,0,.8.4,1.5,1.2,2.2-2.3-.1-4.2-2-4.3-4.3ZM135.2,236.6c-.7-.6-1.1-1.3-1.1-2,0-.7.4-1.4.8-1.8.1-.1.2-.2.3-.3.1.2.3.3.4.4.3.4.7,1,.7,1.7,0,.7-.4,1.4-1.1,2ZM135.4,236.9c.8-.7,1.2-1.4,1.2-2.2,0-.4-.1-.8-.3-1.2.3.2.7.2,1,.2,1.1,0,2-.8,2.4-1.2-.1,2.3-2,4.2-4.3,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M132.8,230.4c.4,0,.7-.3.7-.7s-.3-.7-.7-.7-.7.3-.7.7.3.7.7.7ZM132.8,229.5c.2,0,.3.1.3.3s-.1.3-.3.3-.3-.1-.3-.3.1-.3.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M132.8,234.2c-.4,0-.7.3-.7.7s.3.7.7.7.7-.3.7-.7-.3-.7-.7-.7ZM132.8,235.1c-.2,0-.3-.1-.3-.3s.1-.3.3-.3.3.1.3.3c0,.2-.1.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M137.6,230.4c.4,0,.7-.3.7-.7s-.3-.7-.7-.7-.7.3-.7.7.3.7.7.7ZM137.6,229.5c.2,0,.3.1.3.3s-.1.3-.3.3-.3-.1-.3-.3c0-.2.1-.3.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c192b539-5692-4553-802b-d1fa156251dd",
    d: "M137.6,234.2c-.4,0-.7.3-.7.7s.3.7.7.7.7-.3.7-.7-.3-.7-.7-.7ZM137.6,235.1c-.2,0-.3-.1-.3-.3s.1-.3.3-.3.3.1.3.3c0,.2-.1.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M157.5,271.5v13.3c0,3.9,1.5,3.5,5.5,3.5h36.5v-20.2h-36.5c-4.1,0-5.5-.5-5.5,3.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-8e7a15dd-d9f1-4d22-adec-a0a84785f07c",
    points: "209.3 270.9 209.3 285.4 199.5 285.4 199.5 270.9 209.3 270.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-24e4386a-2ed0-47c6-afca-db6952a1ebfc",
    points: "199.5 285.4 199.5 285.4 209.3 285.4 209.3 278.1 200.8 278.1 200.8 281.7 202.5 281.7 202.5 280.8 202.5 279.9 205.2 279.9 205.2 281.7 209.3 281.7 209.3 285.4 199.5 285.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-5b9d6345-f7d5-4446-96ef-628895db4957",
    points: "199.5 285.4 199.5 285.4 209.3 285.4 209.3 281.7 205.2 281.7 205.2 282.6 202.5 282.6 202.5 281.7 200.8 281.7 200.8 285.4 199.5 285.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-a82f2f8b-8d2f-4610-9121-639e5826719a",
    points: "205.2 279.9 205.2 282.6 202.5 282.6 202.5 279.9 205.2 279.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-ae4d9427-b523-4b15-9b6e-ad108f2e3757",
    points: "202.5 280.8 202.5 281.7 202.5 282.6 205.2 282.6 205.2 280.8 202.5 280.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-a82f2f8b-8d2f-4610-9121-639e5826719a",
    points: "205.2 273.7 205.2 276.4 202.5 276.4 202.5 273.7 205.2 273.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-ae4d9427-b523-4b15-9b6e-ad108f2e3757",
    points: "202.5 274.6 202.5 276.4 205.2 276.4 205.2 274.6 202.5 274.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-716ec5c1-e302-4c04-88d1-b98d60d61f7b",
    points: "199.5 270.9 199.5 278.1 200.8 278.1 200.8 270.9 199.5 270.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-552ee280-7174-4e6c-9fe8-ac80b100ab1a",
    points: "199.5 278.1 199.5 281.7 200.8 281.7 200.8 278.1 199.5 278.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-4a1edc6a-7a81-4964-bda5-a2a706c89440",
    points: "199.5 281.7 199.5 285.4 200.8 285.4 200.8 281.7 199.5 281.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.3,278.1c0,4.4,3.6,7.9,7.9,7.9s7.9-3.6,7.9-7.9-3.6-7.9-7.9-7.9-7.9,3.6-7.9,7.9ZM173.8,270.8c-.6.5-1.9,2-1.9,3.8s.1,1.1.3,1.6c-.5-.2-1.1-.3-1.6-.3-1.8,0-3.2,1.3-3.8,1.9.2-3.7,3.2-6.7,6.9-6.9ZM174.2,271.2c.5.4,1.7,1.8,1.7,3.4s-.3,1.7-1,2.4c-.3.2-.5.5-.7.6-.3-.3-.6-.6-.9-.8-.6-.7-.9-1.5-.9-2.3,0-1.6,1.2-2.9,1.7-3.4ZM167.3,278.1c.4-.5,1.7-1.7,3.4-1.7.8,0,1.5.3,2.3.9.2.3.5.6.8.9-.2.2-.4.4-.6.7-.8.7-1.6,1-2.5,1-1.6,0-2.9-1.2-3.4-1.7ZM174.2,278.6c.1.1.3.3.5.5.5.6,1.2,1.7,1.2,2.9s-.6,2.2-1.7,3.2c-1.1-1-1.7-2-1.7-3.2s.6-2,1.1-2.7c.2-.2.4-.4.7-.7ZM166.9,278.5c.5.6,1.9,1.9,3.8,1.9.6,0,1.1-.1,1.7-.4-.3.5-.4,1.2-.4,1.9,0,1.3.6,2.5,1.9,3.6-3.7-.2-6.7-3.2-6.9-6.9ZM174.6,285.4c1.2-1.1,1.9-2.3,1.9-3.6s-.2-1.4-.5-2c.6.3,1.2.5,1.9.5,1.3,0,2.5-.6,3.6-1.9-.2,3.7-3.2,6.7-6.9,6.9ZM181.1,278.1c-1,1.1-2.1,1.7-3.2,1.7-1.2,0-2.2-.7-2.8-1.2-.2-.2-.3-.4-.5-.5.2-.2.5-.4.7-.7.6-.5,1.6-1,2.6-1.1,1.1,0,2.2.6,3.2,1.7ZM181.5,277.7c-1.1-1.2-2.3-1.9-3.6-1.9-.7,0-1.3.2-1.8.4.3-.5.4-1.1.4-1.7,0-1.8-1.3-3.3-1.9-3.8,3.7.2,6.7,3.2,6.9,6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.2,281.9c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1,1.1-.5,1.1-1.1ZM169.7,281.9c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5-.5-.2-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.2,281.9c0,.6.5,1.1,1.1,1.1s1.1-.5,1.1-1.1-.5-1.1-1.1-1.1-1.1.5-1.1,1.1ZM178.7,281.9c0,.3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.2,274.3c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1,1.1.5,1.1,1.1,1.1c.6,0,1.1-.5,1.1-1.1ZM169.7,274.3c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5-.5-.2-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.2,274.3c0,.6.5,1.1,1.1,1.1s1.1-.5,1.1-1.1-.5-1.1-1.1-1.1c-.6,0-1.1.5-1.1,1.1ZM178.7,274.3c0,.3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M225.7,284.7v-13.3c0-3.9-1.5-3.5-5.5-3.5h-9.1v20.2h9.1c4.1,0,5.5.5,5.5-3.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-3f593725-bee3-4c88-a6d8-7c438bd53176",
    points: "211 247.5 213.4 258.1 215.8 247.5 211 247.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    points: "212.6 255.8 213.4 258.1 214.1 255.8 212.6 255.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    x: 211,
    y: 173.8,
    width: 4.8,
    height: 73.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    x: 211,
    y: 171,
    width: 4.8,
    height: 2.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    points: "215.8 172.8 215.8 173.8 211 173.8 211 172.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M215.8,171v-2.9c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4v2.9h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M184.1,232.3h5c3.4-31,0-63.6,0-63.6h-5s-3.4,35.4,0,63.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    d: "M190.6,199.7c0-.9,0-1.8,0-2.7h-8c0,.9,0,1.8,0,2.7h8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    points: "184.1 232.3 189.1 232.3 187.2 242.5 186.1 242.5 184.1 232.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-eee12681-4c10-4a7f-8c7a-00df7b659c50",
    d: "M186.9,243.9l.2-1.5h-.9l.2,1.5s0,.2.2.2c0,0,.2,0,.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    d: "M189.1,168.8v-1.6c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5v1.6h5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    d: "M189.1,168.8h1.3c.8.2.8,1.5.8,1.5v19.5c0,2.1,1.4,2.6,1.4,2.6.9,0,.7-1,.7-1-.9-.7-.9-1.9-.9-1.9v-19.6s0-2-1.2-2.3h-2.1v1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M440,359.2l-12.3,63.3c-.2,1.3.7,2.5,2.1,2.5h6.5l3.7-65.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-86a05a66-cc6b-4934-9213-d7df16391bbf",
    d: "M440.1,359l-8.1,62.2c-.3,2.1,1.3,3.9,3.4,3.9h11.9l-6.7-66.3-.5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1d623e41-2ebf-4aae-83e7-071780e63a34",
    d: "M440.1,359l-3.6,61.8c-.1,2.3,1.7,4.3,4,4.3h17.8l-18.2-66.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M440,359.5l1.8,61.3c-.1,2.3,1.7,4.3,4,4.3h17.8l-23.6-65.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-18cc7b95-acff-425d-9f99-f19ab21441ff",
    d: "M525.1,425.1h-70.1c-1.7,0-3.2-1.3-3.6-3l-10.7-58.3c-.5-2.6,1.5-5.1,4.2-5.1h69.2c1.7,0,3.2,1.2,3.6,3l10.8,59.1c.4,2.2-1.3,4.3-3.6,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M442.2,371.4h77.5l-2-11c-.2-1-1-1.6-2-1.6h-75c-.4,0-.7.4-.6.8l2.2,11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M444,355.4c-1.9,0-3.4,1.5-3.4,3.4h.6c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7,0,.6-.1.9c-.3.8-.9,1.4-1.7,1.7-.2,0-.5.1-.7.1v.6c.3,0,.6,0,.9-.2,1.1-.3,1.9-1.2,2.2-2.3,0-.3.1-.6.1-.9,0-1.9-1.5-3.4-3.4-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M445,361.8c0,0,0,.1,0,.2,0,.3-.4.5-.7.5s-.7-.3-.7-.7.3-.7.7-.7.4.1.6.3c0,.1.2.3.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M456,355.4c-1.9,0-3.4,1.5-3.4,3.4h.6c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7,0,.6-.1.9c-.3.8-.9,1.4-1.7,1.7-.2,0-.5.1-.7.1v.6c.3,0,.6,0,.9-.2,1.1-.3,1.9-1.2,2.2-2.3,0-.3.1-.6.1-.9,0-1.9-1.5-3.4-3.4-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M457.1,361.8c0,0,0,.1,0,.2,0,.3-.4.5-.7.5s-.7-.3-.7-.7.3-.7.7-.7.4.1.6.3c0,.1.2.3.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M468.1,355.4c-1.9,0-3.4,1.5-3.4,3.4h.6c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7,0,.6-.1.9c-.3.8-.9,1.4-1.7,1.7-.2,0-.5.1-.7.1v.6c.3,0,.6,0,.9-.2,1.1-.3,1.9-1.2,2.2-2.3,0-.3.1-.6.1-.9,0-1.9-1.5-3.4-3.4-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M469.1,361.8c0,0,0,.1,0,.2,0,.3-.4.5-.7.5s-.7-.3-.7-.7.3-.7.7-.7.4.1.6.3c0,.1.2.3.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M480.1,355.4c-1.9,0-3.4,1.5-3.4,3.4h.6c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7,0,.6-.1.9c-.3.8-.9,1.4-1.7,1.7-.2,0-.5.1-.7.1v.6c.3,0,.6,0,.9-.2,1.1-.3,1.9-1.2,2.2-2.3,0-.3.1-.6.1-.9,0-1.9-1.5-3.4-3.4-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M481.2,361.8c0,0,0,.1,0,.2,0,.3-.4.5-.7.5s-.7-.3-.7-.7.3-.7.7-.7.4.1.6.3c0,.1.2.3.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M492.2,355.4c-1.9,0-3.4,1.5-3.4,3.4h.6c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7,0,.6-.1.9c-.3.8-.9,1.4-1.7,1.7-.2,0-.5.1-.7.1v.6c.3,0,.6,0,.9-.2,1.1-.3,1.9-1.2,2.2-2.3,0-.3.1-.6.1-.9,0-1.9-1.5-3.4-3.4-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M493.2,361.8c0,0,0,.1,0,.2,0,.3-.4.5-.7.5s-.7-.3-.7-.7.3-.7.7-.7.4.1.6.3c0,.1.2.3.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M504.2,355.4c-1.9,0-3.4,1.5-3.4,3.4h.6c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7,0,.6-.1.9c-.3.8-.9,1.4-1.7,1.7-.2,0-.5.1-.7.1v.6c.3,0,.6,0,.9-.2,1.1-.3,1.9-1.2,2.2-2.3,0-.3.1-.6.1-.9,0-1.9-1.5-3.4-3.4-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M505.2,361.8c0,0,0,.1,0,.2,0,.3-.4.5-.7.5s-.7-.3-.7-.7.3-.7.7-.7.4.1.6.3c0,.1.2.3.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M516.2,355.4c-1.9,0-3.4,1.5-3.4,3.4h.6c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7,0,.6-.1.9c-.3.8-.9,1.4-1.7,1.7-.2,0-.5.1-.7.1v.6c.3,0,.6,0,.9-.2,1.1-.3,1.9-1.2,2.2-2.3,0-.3.1-.6.1-.9,0-1.9-1.5-3.4-3.4-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-049f6520-edbe-48d3-8a64-63cdd7719105",
    d: "M517.3,361.8c0,0,0,.1,0,.2,0,.3-.4.5-.7.5s-.7-.3-.7-.7.3-.7.7-.7.4.1.6.3c0,.1.2.3.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M487,392h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M496.9,392h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-86a05a66-cc6b-4934-9213-d7df16391bbf",
    d: "M506.7,392h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M457.3,392h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M453,380.3h-1.7c-.2,0-.4-.2-.4-.4l-.3-1.7c0-.2,0-.4.3-.4h1.7c.2,0,.4.2.4.4l.3,1.7c0,.2,0,.4-.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M467.2,392h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M477.1,392h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-86a05a66-cc6b-4934-9213-d7df16391bbf",
    d: "M516.6,392h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M485.3,383.5h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M495.2,383.5h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-86a05a66-cc6b-4934-9213-d7df16391bbf",
    d: "M505.1,383.5h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-86a05a66-cc6b-4934-9213-d7df16391bbf",
    d: "M515,383.5h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M488.7,401.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M498.6,401.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-86a05a66-cc6b-4934-9213-d7df16391bbf",
    d: "M508.5,401.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M459.1,401.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M469,401.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M478.8,401.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-86a05a66-cc6b-4934-9213-d7df16391bbf",
    d: "M518.4,401.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M490.5,410.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M500.3,410.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-86a05a66-cc6b-4934-9213-d7df16391bbf",
    d: "M510.2,410.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M460.8,410.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M470.7,410.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M480.6,410.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-86a05a66-cc6b-4934-9213-d7df16391bbf",
    d: "M520.1,410.1h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M492.1,418.6h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M502,418.6h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-86a05a66-cc6b-4934-9213-d7df16391bbf",
    d: "M511.9,418.6h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M462.5,418.6h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M472.3,418.6h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M482.2,418.6h-3.9c-.5,0-.9-.4-1-.8l-.8-3.9c0-.5.2-.8.7-.8h3.9c.5,0,.9.4,1,.8l.8,3.9c0,.5-.2.8-.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M464.9,378.7h-10.4c-.2,0-.3-.1-.3-.3h0c0-.2.1-.3.3-.3h10.4c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2459c03a-082c-47a0-9940-0c9ba620a998",
    d: "M465.2,380h-10.4c-.2,0-.3-.1-.3-.3h0c0-.2.1-.3.3-.3h10.4c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M453.8,369.4h-3.6c-.3,0-.5-.2-.5-.5h0c0-.3.2-.5.5-.5h3.6c.3,0,.5.2.5.5h0c0,.3-.2.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M463.6,369.4h-3.6c-.3,0-.5-.2-.5-.5h0c0-.3.2-.5.5-.5h3.6c.3,0,.5.2.5.5h0c0,.3-.2.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M473.3,369.4h-3.6c-.3,0-.5-.2-.5-.5h0c0-.3.2-.5.5-.5h3.6c.3,0,.5.2.5.5h0c0,.3-.2.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M483.1,369.4h-3.6c-.3,0-.5-.2-.5-.5h0c0-.3.2-.5.5-.5h3.6c.3,0,.5.2.5.5h0c0,.3-.2.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M492.9,369.4h-3.6c-.3,0-.5-.2-.5-.5h0c0-.3.2-.5.5-.5h3.6c.3,0,.5.2.5.5h0c0,.3-.2.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M502.6,369.4h-3.6c-.3,0-.5-.2-.5-.5h0c0-.3.2-.5.5-.5h3.6c.3,0,.5.2.5.5h0c0,.3-.2.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9e42a0e8-0a2c-4043-84f6-3c9677620577",
    d: "M512.4,369.4h-3.6c-.3,0-.5-.2-.5-.5h0c0-.3.2-.5.5-.5h3.6c.3,0,.5.2.5.5h0c0,.3-.2.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-79de07c4-6952-4263-986f-214ff339c15b",
    d: "M489.9,383.6c-.8,0-1.4-.2-1.7-.7-.6-.9-.1-2.2,1.4-3.9,1.1-1.2,2.4-2.1,2.4-2.2,0,0,.1,0,.2,0,0,0,0,.1,0,.2,0,0-5,3.7-3.7,5.7.4.6,1.3.7,2,.6,1.2-.1,2.8-.8,4.3-1.8,1.5-1,2.6-2.1,2.9-3.1.2-.6.2-1.1-.2-1.3-.5-.3-1.4-.3-2.6,0-1.1.3-2.3.9-3,1.5,0,0-.1,0-.2,0,0,0,0-.1,0-.2.7-.6,1.9-1.2,3-1.5,1.3-.3,2.3-.3,2.8,0,.3.2.6.7.3,1.6-.4,1-1.5,2.2-3,3.2-1.5,1-3.1,1.7-4.4,1.8-.2,0-.3,0-.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M321.7,417.2c0,1.4-1.1,2.5-2.5,2.5h-84c-1.4,0-2.5-1.1-2.5-2.5v-57c0-1.4,1.1-2.5,2.5-2.5h84c1.4,0,2.5,1.1,2.5,2.5v57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    d: "M321.7,390.7c0,1.4-1.1,2.5-2.5,2.5h-84c-1.4,0-2.5-1.1-2.5-2.5v-36.3c0-1.4,1.1-2.5,2.5-2.5h84c1.4,0,2.5,1.1,2.5,2.5v36.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-138b7916-802c-4076-b291-746c2bdc540f",
    d: "M232.7,357v31.2c0,1.4,1.1,2.5,2.5,2.5h84c1.4,0,2.5-1.1,2.5-2.5v-31.2h-89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    x: 232.7,
    y: 349.6,
    width: 89,
    height: 7.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5",
    x: 244.4,
    y: 403.5,
    width: 11.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    x: 247.1,
    y: 388.3,
    width: 6.5,
    height: 23.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5",
    x: 246.5,
    y: 394.9,
    width: 7.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5",
    d: "M244.4,397.1v6.5h2.1v-8.6c-1.2,0-2.1,1-2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5",
    d: "M256.2,397.1c0-1.2-1-2.1-2.1-2.1v8.6h2.1v-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5",
    d: "M251.4,399.3c0,.6-.5,1.1-1.1,1.1h0c-.6,0-1.1-.5-1.1-1.1v-5.9c0-.6.5-1.1,1.1-1.1h0c.6,0,1.1.5,1.1,1.1v5.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5",
    x: 298.2,
    y: 403.5,
    width: 11.8,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    x: 300.8,
    y: 388.3,
    width: 6.5,
    height: 23.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5",
    x: 300.3,
    y: 394.9,
    width: 7.5,
    height: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5",
    d: "M310,397.1v6.5h-2.1v-8.6c1.2,0,2.1,1,2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5",
    d: "M298.2,397.1c0-1.2,1-2.1,2.1-2.1v8.6h-2.1v-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5",
    d: "M303,399.3c0,.6.5,1.1,1.1,1.1h0c.6,0,1.1-.5,1.1-1.1v-5.9c0-.6-.5-1.1-1.1-1.1h0c-.6,0-1.1.5-1.1,1.1v5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    d: "M276.2,392s1,27.6-3.8,27.6h4.8v-27.6h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    d: "M278.1,392s-1,27.6,3.8,27.6h-4.8v-27.6h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    d: "M234.1,391.7l-1.4-.9h0v26.3c0,1.4,1.1,2.5,2.5,2.5h3.7c-4.8,0-4.7-27.9-4.7-27.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    d: "M320.2,391.7l1.4-.9h0v26.3c0,1.4-1.1,2.5-2.5,2.5h-3.7c4.8,0,4.7-27.9,4.7-27.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-884bb9cf-042e-49b6-bb61-63e84ce1dce5",
    d: "M260.2,347.2v5.5s.4.6,2.2.6,2.5-.6,2.5-.6v-5.5c0-1.3.7-2.4,1.7-3.1v-5c-3.7.9-6.4,4.2-6.4,8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-29a2f679-1508-4734-914b-12febce24bef",
    d: "M288.2,339.1v5c1,.6,1.6,1.8,1.6,3.1v5.5s.4.6,2.6.6,2.1-.6,2.1-.6v-5.5c0-3.9-2.7-7.2-6.3-8.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-2409ca6d-a3bf-479d-acc7-c70dbae95e5a",
    x: 266.1,
    y: 338.6,
    width: 22.6,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-698d1253-63a3-4b79-af5b-caeff2b2347d",
    x: 235.1,
    y: 418,
    width: 84.3,
    height: 1.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-29a2f679-1508-4734-914b-12febce24bef",
    points: "266.1 342.2 286.5 341.9 286.5 339.5 266.1 339.2 266.1 342.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider3);
export default __webpack_public_path__ + "static/media/slider3.d6dc613ff12fb8db300d7fd7cbbc3db2.svg";
export { ForwardRef as ReactComponent };